// import '@capacitor-community/http';
import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonDatetime, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonNote, IonPage, IonPopover, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonTitle, IonToast, IonToggle, IonToolbar, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { alertOutline, arrowBack, closeOutline, copy, ellipsisVertical, informationCircleOutline, listOutline, logoWhatsapp, pencilOutline, timerOutline, trashOutline } from 'ionicons/icons';
import QRCode from 'qrcode';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { api99FoodAuthorizationUrl, api99FoodDiagnostic, api99FoodSetStatus, api99FoodShopDetail, api99FoodShops, api99FoodToken, apiDominioCheckBr, apiEmpresaConfiguracaoRoboSalvar, apiIfoodAouthUserCode, apiIfoodAouthUserToken, apiIfoodDeleteMerchantsInterruptions, apiIfoodMerchants, apiIfoodMerchantsDetails, apiIfoodMerchantsInterruptions, apiIfoodMerchantsOpeningHours, apiIfoodMerchantsStatus, apiIfoodPostMerchantsInterruptions, apiIfoodPutMerchantsOpeningHours, apiMarketingBuscarConfiguracao, apiMercadoPagoBuscarConfiguracao, apiMercadoPagoCriarConfiguracao, apiMercadoPagoOperationMode, apiMercadoPagoTerminals, apiWhatsappWebQrcode, apiWhatsappWebStart, onboardingAtualizarEtapa, requestService } from '../../../../../Utils/Services';
import IntegrationCard from '../../../../../components/IntegrationCard/IntegrationCard';
import OnboardingContextBanner from '../../../../../components/Onboarding/OnboardingContextBanner';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import IntegracaoAnalyticsModal from './IntegracaoAnalyticsModal';
import IntegracaoMetaAdsModal from './IntegracaoMetaAdsModal';
import './Integracoes.css';
import WhatsAppMetaCard from './WhatsAppMetaCard';
import iconGoogleAnalytics from "./imgs/googleAnalyticsIcon.svg";
import iconIfood from "./imgs/ifoodBigIcon.svg";
import iconMercadopago from "./imgs/mercadopagoIcon.svg";
import iconMetaAds from "./imgs/metaAdsIcon.svg";
import icon99Food from "./imgs/novenovefoodIcon.svg";
import iconPixAutomatizado from "./imgs/pixIcon.svg";
import iconRegistroBr from "./imgs/registro-br.svg";
import iconRobo from "./imgs/robo.svg";

type Props = {
  abrirMenu: boolean;
};

type ModoFallbackRobo = '' | 'aguardar_atendimento';

function whatsappMetaHabilitado(company: any) {
  return company?.funcionalidades?.whatsappMeta?.habilitado === true;
}

type InfoIntegracaoProps = {
  triggerId: string;
  children: React.ReactNode;
};

const InfoIntegracao: React.FC<InfoIntegracaoProps> = ({ triggerId, children }: InfoIntegracaoProps) => (
  <>
    <span id={triggerId} className="integracoes-info-trigger" role="button" tabIndex={0}>
      <IonIcon icon={informationCircleOutline} style={{ fontSize: 14 }} />
    </span>
    <IonPopover
      className="integracoes-popover-host"
      trigger={triggerId}
      showBackdrop={false}
      side="bottom"
      alignment="start"
    >
      <div className="integracoes-popover">
        {children}
      </div>
    </IonPopover>
  </>
);

const Integracoes: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const [showToast2, setShowToast2] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [showLoading, setShowLoading] = useState(true);
  const [showSucesso, setShowSucesso] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const whatsappMetaAtivadoNaConta = whatsappMetaHabilitado(dadosEmpresa);
  const exibirCardRobozinho = true; // !whatsappMetaAtivadoNaConta;
  const exibirCardWhatsappOficial = whatsappMetaAtivadoNaConta;
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [mostartAlerta] = useIonAlert();

  const [qrCodeData, setQRCodeData] = useState<any>();

  const [ativarWhatsapp1, setAtivarWhatsapp1] = useState<boolean>(false);
  const [showModalConfiguracaoRobo, setShowModalConfiguracaoRobo] = useState<boolean>(false);
  const [tipoRoboLabel, setTipoRoboLabel] = useState<string>("simples");
  const [modoFallbackRobo, setModoFallbackRobo] = useState<ModoFallbackRobo>('');
  const [recuperadorVendasAtivo, setRecuperadorVendasAtivo] = useState<boolean>(true);
  const [intervaloInterrupcaoRoboMinutos, setIntervaloInterrupcaoRoboMinutos] = useState<number>(10);
  const [salvandoConfiguracaoRobo, setSalvandoConfiguracaoRobo] = useState<boolean>(false);
  const qrPollingIntervalRef = useRef<any>(null);
  const qrPollingTimeoutRef = useRef<any>(null);

  const stopQrPolling = () => {
    if (qrPollingIntervalRef.current) {
      clearInterval(qrPollingIntervalRef.current);
      qrPollingIntervalRef.current = null;
    }
    if (qrPollingTimeoutRef.current) {
      clearTimeout(qrPollingTimeoutRef.current);
      qrPollingTimeoutRef.current = null;
    }
  };

  const [ativarIfood1, setAtivarIfood1] = useState<boolean>(false);

  // 99Food state
  const [ativar99Food1, setAtivar99Food1] = useState<boolean>(false);
  const [ativar99Food2, setAtivar99Food2] = useState<boolean>(false);
  const [shopId99Food, setShopId99Food] = useState<string>("");
  const [authorizationUrl99Food, setAuthorizationUrl99Food] = useState<string>("");
  const [showLojas99Food, setShowLojas99Food] = useState<boolean>(false);
  const [listaLojas99Food, setListaLojas99Food] = useState<any>([]);
  const [showDetalhe99Food, setShowDetalhe99Food] = useState<boolean>(false);
  const [detalhe99Food, setDetalhe99Food] = useState<any>(null);
  const [showDiagnostico99Food, setShowDiagnostico99Food] = useState<boolean>(false);
  const [diagnostico99Food, setDiagnostico99Food] = useState<any>(null);

  const [mercadoPago1, setMercadoPago1] = useState<boolean>(false);
  const [mercadoPago2, setMercadoPago2] = useState<boolean>(false);

  const [mercadoPagoAccessToken, setMercadoPagoAccessToken] = useState<string>("");
  const [mercadoPagoConfigurado, setMercadoPagoConfigurado] = useState<boolean>(false);
  const [listaMercadoPagoTerminals, setListaMercadoPagoTerminals] = useState<any>([]);

  const [userCode, setUserCode] = useState<any>();
  const [authorizationCodeVerifier, setAuthorizationCodeVerifier] = useState<any>();
  const [ativarIfood2, setAtivarIfood2] = useState<boolean>(false);
  const [authorizationCode, setAuthorizationCode] = useState<any>();


  const [showLojasIfood, setShowLojasIfood] = useState<boolean>(false);
  const [listaLojasIfood, setListaLojasIfood] = useState<any>([]);

  const [showDetalheLojaIfood, setShowDetalheLojaIfood] = useState<boolean>(false);
  const [detalheLojaIfood, setDetalheLojaIfood] = useState<any>();

  const [showStatusLojaIfood, setShowStatusLojaIfood] = useState<boolean>(false);
  const [statusLojaIfood, setStatusLojaIfood] = useState<any>([]);

  const [showInterruptionsLojaIfood, setShowInterruptionsLojaIfood] = useState<boolean>(false);
  const [interruptionsLojaIfood, setInterruptionsLojaIfood] = useState<any>([]);

  const [showFecharLojaIfood, setShowFecharLojaIfood] = useState<boolean>(false);
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [selectedReason, setSelectedReason] = useState<string>("");

  const [showPausaProgramada, setShowPausaProgramada] = useState<boolean>(false);
  const [pauseTitle, setPauseTitle] = useState<any>(''); // Armazena o título da pausa programada
  const [startDate, setStartDate] = useState<any>(''); // Armazena a data de início
  const [startTime, setStartTime] = useState<any>(''); // Armazena a hora de início
  const [endDate, setEndDate] = useState<any>(''); // Armazena a data de término
  const [endTime, setEndTime] = useState<any>(''); // Armazena a hora de término

  const [showOpenHoursLojaIfood, setShowOpenHoursLojaIfood] = useState<boolean>(false);
  const [openHoursLojaIfood, setOpenHoursLojaIfood] = useState<any>([]);

  const [showAlterarHorarioLojaIfood, setShowAlterarHorarioLojaIfood] = useState<boolean>(false);

  const [showModalPixAutomatizado, setShowModalPixAutomatizado] = useState<boolean>(false);

  // Domínio .br
  const [showModalDominio, setShowModalDominio] = useState<boolean>(false);
  const [dominioConsulta, setDominioConsulta] = useState<string>("");
  const [dominioResult, setDominioResult] = useState<any>(null);
  const [dominioLoading, setDominioLoading] = useState<boolean>(false);
  const domainRequested = (dominioConsulta || '').trim().toLowerCase();


  const [showPopoverGrid, setShowPopoverGrid] = useState(false);
  const [popoverEventGrid, setPopoverEventGrid] = useState(null);
  const [itemSelecionado, setItemSelecionado] = useState<any>(null); // Variável para armazenar o item clicado


  const [idOpenHour, setIdOpenHour] = useState<any>();
  const [dayOfWeekOpenHour, setDayOfWeekOpenHour] = useState<any>();
  const [startOpenHour, setStartOpenHour] = useState<any>();
  const [durationOpenHour, setDurationOpenHour] = useState<any>();

  const openPopoverGrid = (e: any, item: any) => {
    e.persist();
    setPopoverEventGrid(e); // Seta o evento para abrir o popover
    setItemSelecionado(item); // Seta o item clicado
    setShowPopoverGrid(true); // Abre o popover
  };

  const closePopoverGrid = () => {
    setShowPopoverGrid(false); // Fecha o popover
    setPopoverEventGrid(null); // Reseta o evento
    setItemSelecionado(null); // Reseta o item selecionado
  };


  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConfiguracoesIntegracoes();
    carregarConfiguracoesRobozinho();
    carregarStatusMarketing();
  });

  // Analytics & Marketing (config compartilhada em DynamoDB, exposta em 2 cards)
  const [showModalMetaAds, setShowModalMetaAds] = useState<boolean>(false);
  const [showModalAnalytics, setShowModalAnalytics] = useState<boolean>(false);
  const [metaAdsAtivo, setMetaAdsAtivo] = useState<boolean>(false);
  const [analyticsAtivo, setAnalyticsAtivo] = useState<boolean>(false);

  function carregarStatusMarketing() {
    if (!loja) return;
    const url = apiMarketingBuscarConfiguracao.url.replace("{id}", loja.replaceAll(/#/g, '%23'));
    requestService(
      url,
      { method: apiMarketingBuscarConfiguracao.method },
      history,
      (response: any) => {
        const item = (response && response.Item) || {};
        // Retrocompatível: se flags específicas não existem, herda do `ativo` legado.
        const meta = item.metaAdsAtivo === true || (item.metaAdsAtivo === undefined && item.ativo === true);
        const ga = item.analyticsAtivo === true || (item.analyticsAtivo === undefined && item.ativo === true);
        setMetaAdsAtivo(!!meta);
        setAnalyticsAtivo(!!ga);
      },
      (err: any) => {
        console.log("[Marketing] erro ao carregar status", err);
      }
    );
  }

  function carregarConfiguracoesIntegracoes() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      setMercadoPagoAccessToken("");

      requestService(apiMercadoPagoBuscarConfiguracao.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: apiMercadoPagoBuscarConfiguracao.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);
          setMercadoPagoConfigurado(response?.Item?.configurado === true);
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          // history.replace("/login/");
          setShowLoading(false);
        });

    }

    consultar();
  }

  function abrirAtivacaoMercadoPago() {
    setMercadoPagoAccessToken("");
    setMercadoPago1(true);
  }

  function fecharAtivacaoMercadoPago() {
    setMercadoPagoAccessToken("");
    setMercadoPago1(false);
  }

  function aplicarConfiguracaoRobo(response: any) {
    const item = response?.Item || response || {};
    const modo = item.modoFallbackRobo === 'aguardar_atendimento' ? 'aguardar_atendimento' : '';

    setTipoRoboLabel(item.tipoRoboLabel || getTipoRoboLabel(item.tipoRobo));
    setModoFallbackRobo(modo);
    setRecuperadorVendasAtivo(item.recuperadorVendasAtivo === false ? false : true);
    setIntervaloInterrupcaoRoboMinutos(normalizarIntervaloInterrupcao(item.intervaloInterrupcaoRoboMinutos));
  }

  function getTipoRoboLabel(value: any) {
    if (value === 'simples') return 'Robô simples';
    if (value === 'ia') return 'Robô com IA';
    if (value === 'suporte') return 'Robô de suporte';
    return 'Robô simples';
  }

  function normalizarIntervaloInterrupcao(valor: any) {
    const minutos = Number(valor);
    if (!Number.isInteger(minutos) || minutos < 1 || minutos > 1440) {
      return 10;
    }
    return minutos;
  }

  function carregarConfiguracoesRobozinho() {
    try {
      aplicarConfiguracaoRobo(dadosEmpresa);
    } catch (err) {
      console.error('Erro ao carregar configuração do robô', err);
    }

  }

  function abrirModalConfiguracaoRobo() {
    aplicarConfiguracaoRobo(dadosEmpresa);
    setShowModalConfiguracaoRobo(true);
  }

  function cancelarConfiguracaoRobo() {
    aplicarConfiguracaoRobo(dadosEmpresa);
    setShowModalConfiguracaoRobo(false);
  }

  function salvarConfiguracaoRobo() {
    if (!loja) return;

    setSalvandoConfiguracaoRobo(true);

    const payload = {
      modoFallbackRobo: modoFallbackRobo === 'aguardar_atendimento' ? 'aguardar_atendimento' : '',
      recuperadorVendasAtivo,
      intervaloInterrupcaoRoboMinutos: normalizarIntervaloInterrupcao(intervaloInterrupcaoRoboMinutos)
    };

    requestService(apiEmpresaConfiguracaoRoboSalvar.url.replace("{id}", loja.replaceAll(/#/g, '%23')), {
      method: apiEmpresaConfiguracaoRoboSalvar.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify(payload),
      credentials: 'include'
    },
      history,
      (response: any) => {
        const item = response?.Item || response || {};
        const dadosEmpresaAtualizados = { ...(dadosEmpresa || {}), ...item };
        setDadosEmpresa(dadosEmpresaAtualizados);
        aplicarConfiguracaoRobo(dadosEmpresaAtualizados);
        setTextToast("Configurações do robô salvas com sucesso.");
        setShowToast(true);
        setShowModalConfiguracaoRobo(false);
        setSalvandoConfiguracaoRobo(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Não foi possível salvar as configurações do robô. Tente novamente.");
        setShowToast(true);
        setSalvandoConfiguracaoRobo(false);
      });
  }

  function abrirWhatsAppContratacao() {
    if (!domainRequested) return;
    const url = `https://api.whatsapp.com/send?phone=5511963927646&text=${encodeURIComponent(`Eu quero contratar o dominio ${domainRequested} para loja ${loja}`)}`;
    window.open(url, '_blank', 'noopener');
  }

  function validarDominioBr() {
    const domain = (dominioConsulta || '').trim().toLowerCase();
    if (!domain) {
      setTextToast('Informe um domínio para consultar.');
      setShowToast(true);
      return;
    }
    setDominioLoading(true);
    requestService(
      `${apiDominioCheckBr.url}?domain=${encodeURIComponent(domain)}`,
      {
        method: apiDominioCheckBr.method,
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      },
      history,
      (response: any) => {
        const result = response?.data ?? response;
        setDominioResult(result);
        // Se estiver disponível, pergunta se deseja prosseguir com a contratação
        if (result?.status === 'available') {
          mostartAlerta({
            header: 'Domínio disponível',
            message: `O domínio ${domain} está disponível. Deseja seguir com a contratação por R$ 99,90/ano?`,
            buttons: [
              { text: 'Agora não', role: 'cancel' },
              {
                text: 'Contratar',
                handler: () => {
                  // Fecha o modal e abre o WhatsApp para contratação
                  setShowModalDominio(false);
                  abrirWhatsAppContratacao();
                }
              }
            ]
          });
        }
        // Se não estiver disponível, notifica via toast conforme solicitado
        else if (result?.status && result.status !== 'available') {
          setTextToast('Domínio indisponível. Tente outro nome.');
          setShowToast(true);
        }
        setDominioLoading(false);
      },
      (error: any) => {
        setTextToast(error?.message || 'Falha ao consultar domínio.');
        setShowToast(true);
        setDominioLoading(false);
      },
      true,
      false
    );
  }

  function getButtonsGrid(value: any) {

    let resultado: any = [];

    if (acessos?.configuracoes == 'edicao') {


      resultado.push(
        {
          text: 'Detalhes',
          disabled: false,
          icon: listOutline,
          handler: () => {
            getMerchantsDetail();
          }
        });


      resultado.push(
        {
          text: 'Status',
          disabled: false,
          icon: informationCircleOutline,
          handler: () => {
            getMerchantsStatus();
          }
        });
      resultado.push(
        {
          text: 'Interrupções',
          disabled: false,
          icon: alertOutline,
          handler: () => {
            getMerchantsInterruptions();
          }
        });

      resultado.push(
        {
          text: 'Horários',
          disabled: false,
          icon: timerOutline,
          handler: () => {
            getMerchantsOpenHours();
          }
        });
    }


    resultado.push(
      {
        text: 'Cancelar',
        disabled: false,
        icon: closeOutline,
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      });


    return resultado;
  }

  function readListalojasIfood() {
    return (
      <>
        <IonPopover
          isOpen={showPopoverGrid}
          event={popoverEventGrid}
          onDidDismiss={closePopoverGrid}
        >
          <IonList>
            {getButtonsGrid(itemSelecionado).map((button: any, btnIndex: number) => (
              <IonItem key={btnIndex} lines="none" disabled={button.disabled} button onClick={() => {
                if (button.handler) button.handler();
                closePopoverGrid(); // Fecha o popover após a ação
              }}>
                <IonIcon icon={button.icon} slot="start" />
                <IonLabel>{button.text}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        </IonPopover>


        {listaLojasIfood.map((value: any, index: any) => (

          <IonItem
            key={"lojasifood" + value.id}
            button
            onClick={() => window.localStorage.setItem("merchantIdIfood", value.id)}
            color={window.localStorage.getItem("merchantIdIfood") === value.id ? 'tertiary' : ''}
          >
            <IonLabel>{value.name}</IonLabel>
            <div style={{ position: "absolute", right: "6px", zIndex: 9999999, textAlign: "right" }}>

              <IonButtons slot="end">
                <IonButton color="primary" onClick={(e) => openPopoverGrid(e, value)}>
                  <IonIcon slot="icon-only" icon={ellipsisVertical} />
                </IonButton>
              </IonButtons>

            </div>
          </IonItem>
        ))}
      </>
    );


  }

  function salvarTerminalMercadoPago(terminal: any, externalPosId: string) {
    window.localStorage.setItem("externalPosIdMercadoPago", externalPosId);
    window.localStorage.setItem("terminalIdMercadoPago", terminal.id);
    setListaMercadoPagoTerminals((terminaisAtuais: any[]) => terminaisAtuais.map((item: any) =>
      String(item.pos_id) === String(terminal.pos_id)
        ? { ...item, external_pos_id: externalPosId }
        : item
    ));
  }

  function selecionarTerminalMercadoPago(terminal: any) {
    const externalPosId = String(terminal.external_pos_id || '').trim();
    if (externalPosId) {
      salvarTerminalMercadoPago(terminal, externalPosId);
      setTextToast("Terminal Mercado Pago selecionado.");
      setShowToast(true);
      return;
    }

    if (!terminal.pos_id) {
      setTextToast("Este terminal não possui um caixa Mercado Pago associado.");
      setShowToast(true);
      return;
    }

    setShowLoading(true);
    const params = {
      action: "configure_external_pos_id",
      posId: terminal.pos_id
    };

    requestService(
      apiMercadoPagoOperationMode.url + "?empresaId=" + encodeURIComponent(loja),
      {
        method: apiMercadoPagoOperationMode.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(params),
        credentials: 'include'
      },
      history,
      (response: any) => {
        const externalPosIdConfigurado = String(response?.data?.external_pos_id || '').trim();
        if (!externalPosIdConfigurado) {
          setTextToast("O Mercado Pago não confirmou o identificador externo do caixa.");
          setShowToast(true);
          return;
        }

        salvarTerminalMercadoPago(terminal, externalPosIdConfigurado);
        setTextToast("Caixa configurado e terminal selecionado com sucesso.");
        setShowToast(true);
      },
      (error: any) => {
        setTextToast(error?.message || "Não foi possível configurar o caixa no Mercado Pago.");
        setShowToast(true);
      }
    ).finally(() => setShowLoading(false));
  }

  function readListaTerminals() {
    return (
      <>

        {listaMercadoPagoTerminals.map((value: any) => {
          const terminalSelecionado = window.localStorage.getItem("terminalIdMercadoPago") === value.id;

          return (
            <IonItem
              key={"terminal-mercadopago-" + value.id}
              button
              onClick={() => selecionarTerminalMercadoPago(value)}
              color={terminalSelecionado ? 'tertiary' : ''}
            >
              <IonLabel color={terminalSelecionado ? "light" : undefined}>
                <div>{value.id}</div>
                <IonNote
                  style={{
                    color: terminalSelecionado
                      ? "#ffffff"
                      : value.external_pos_id
                        ? "var(--ion-color-medium)"
                        : "var(--ion-color-danger)"
                  }}
                >
                  {value.external_pos_id
                    ? `Caixa: ${value.external_pos_id}`
                    : "Caixa sem identificador externo — clique para configurar"}
                </IonNote>
              </IonLabel>
              <div style={{ position: "absolute", right: "6px", zIndex: 9999999, textAlign: "right" }}>

                <IonButtons slot="end">
                  <IonButton color="primary" onClick={(e) => {
                    e.stopPropagation();
                    patchOperationMode(value.id, value.operating_mode == "PDV" ? "STANDALONE" : "PDV");
                  }}>
                    {value.operating_mode == "PDV" ? "Desabilitar PDV" : "Habilitar PDV"}
                  </IonButton>
                </IonButtons>

              </div>
            </IonItem>
          );
        })}
      </>
    );


  }


  function getUserCode() {

    const consultar = async () => {

      setShowLoading(true);

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(apiIfoodAouthUserCode.url, {
        method: apiIfoodAouthUserCode.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);
          setUserCode(response.data.userCode || '');
          setAuthorizationCodeVerifier(response.data.authorizationCodeVerifier || '');
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }


  function getTokenIfood() {

    const consultar = async () => {

      setShowLoading(true);

      console.log("aasasasasa", loja);
      let id = loja;

      const objectRequest = {
        authorizationCode,
        authorizationCodeVerifier,
        empresaid: loja
      }

      requestService(apiIfoodAouthUserToken.url, {
        method: apiIfoodAouthUserToken.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objectRequest),
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);

          setTextToast("Integração realizada com sucesso.");
          setShowToast(true);

          window.localStorage.setItem("integradoIfood", "true");

          getMerchants();

          setShowLoading(false);
          setAtivarIfood2(false);
        },
        (error: any) => {
          console.log(error);
          setTextToast("Código inválido.");
          setShowToast(true);
          setShowLoading(false);
        });

    }

    consultar();
  }

  // ========================================
  // 99FOOD FUNCTIONS
  // ========================================

  function normalize99FoodIdString(value: any, label: string) {
    if (typeof value === "number") {
      console.warn(`[99FOOD] ${label} recebido como number no frontend`);
    }

    return value === undefined || value === null ? "" : String(value).trim();
  }

  function format99FoodShopPhone(shopPhone: any) {
    if (!Array.isArray(shopPhone) || shopPhone.length === 0) return "";

    return shopPhone
      .map((item: any) => {
        const callingCode = item?.calling_code ? `+${item.calling_code} ` : "";
        const phone = item?.phone ? String(item.phone) : "";
        return `${callingCode}${phone}`.trim();
      })
      .filter(Boolean)
      .join(" / ");
  }

  function format99FoodShopStatus(bizStatus: any, subBizStatus: any) {
    if (bizStatus === 1) return "Aberta";
    if (bizStatus === 2) return "Fechada";
    if (bizStatus === 3) return "Pausada";
    if (bizStatus === undefined || bizStatus === null || bizStatus === "") return "Nao informado";
    return subBizStatus ? `Status ${bizStatus}/${subBizStatus}` : `Status ${bizStatus}`;
  }

  function format99FoodPromiseTime(seconds: any) {
    const totalSeconds = Number(seconds || 0);
    if (!totalSeconds) return "";

    const minutes = Math.round(totalSeconds / 60);
    return `${minutes} min`;
  }

  function format99FoodBusinessHours(bizDayTime: any) {
    if (!Array.isArray(bizDayTime) || bizDayTime.length === 0) return "";

    const daysMap: any = {
      1: "Seg",
      2: "Ter",
      3: "Qua",
      4: "Qui",
      5: "Sex",
      6: "Sab",
      7: "Dom"
    };

    return bizDayTime
      .map((item: any) => {
        const days = Array.isArray(item?.biz_day)
          ? item.biz_day.map((day: any) => daysMap[day] || String(day)).join(", ")
          : "";
        const periods = Array.isArray(item?.biz_time)
          ? item.biz_time.map((time: any) => `${time?.begin || "--:--"}-${time?.end || "--:--"}`).join(", ")
          : "";

        return [days, periods].filter(Boolean).join(": ");
      })
      .filter(Boolean)
      .join(" | ");
  }

  function map99FoodShopFields(source: any, fallback: any = {}) {
    const payload = source?.data || source || {};
    const fallbackShopId = fallback.shopId99Food || fallback.shopId || "";
    const shopId99Food = payload?.shop_id !== undefined && payload?.shop_id !== null
      ? String(payload.shop_id)
      : fallbackShopId;
    const appShopId = payload?.app_shop_id || fallback.appShopId || "";
    const shopName = payload?.name || fallback.shopName || fallback.name || shopId99Food || "Loja 99Food";
    const shopAddress = payload?.addr || payload?.poi_name || fallback.shopAddress || fallback.addr || "";
    const shopPhone = format99FoodShopPhone(payload?.shop_phone) || fallback.shopPhone || "";
    const bizStatus = payload?.biz_status ?? fallback.bizStatus;
    const subBizStatus = payload?.sub_biz_status ?? fallback.subBizStatus;
    const statusLabel = payload?.statusLabel || fallback.statusLabel || format99FoodShopStatus(bizStatus, subBizStatus);
    const categoryName = payload?.main_categories?.main_category?.name || fallback.categoryName || "";
    const promiseProduceTimeLabel = format99FoodPromiseTime(payload?.promise_produce_time || fallback.promiseProduceTime);
    const businessHoursLabel = format99FoodBusinessHours(payload?.biz_day_time || fallback.bizDayTime);
    const autoSwitch = payload?.auto_switch ?? fallback.autoSwitch;

    return {
      ...fallback,
      appShopId,
      shopId99Food,
      shopName,
      shopAddress,
      shopPhone,
      statusLabel,
      isOpen: bizStatus === 1,
      bizStatus,
      subBizStatus,
      categoryName,
      promiseProduceTime: payload?.promise_produce_time || fallback.promiseProduceTime || 0,
      promiseProduceTimeLabel,
      businessHoursLabel,
      autoSwitch,
      autoSwitchLabel: autoSwitch === 1 ? "Ativado" : autoSwitch === 0 ? "Desativado" : "",
      logoImg: payload?.logo_img || fallback.logoImg || "",
      headImg: payload?.head_img || fallback.headImg || "",
      announce: payload?.announce || fallback.announce || "",
      poiName: payload?.poi_name || fallback.poiName || "",
      lat: payload?.lat ?? fallback.lat,
      lng: payload?.lng ?? fallback.lng,
    };
  }

  function fetch99FoodShopDetailMap(appShopId: string) {
    const id = loja;
    const normalizedAppShopId = normalize99FoodIdString(appShopId, "appShopId");

    return new Promise<any>((resolve) => {
      requestService(api99FoodShopDetail.url.replace("{id}", id.replace(/#/g, '%23')).concat("?appShopId=", encodeURIComponent(normalizedAppShopId)), {
        method: api99FoodShopDetail.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          resolve(map99FoodShopFields(response.data, { appShopId: normalizedAppShopId }));
        },
        () => {
          resolve(null);
        });
    });
  }

  function getAuthorizationUrl99Food() {
    setShowLoading(true);
    let id = loja;
    const normalizedShopId99Food = normalize99FoodIdString(shopId99Food, "shopId99Food");

    requestService(api99FoodAuthorizationUrl.url.replace("{id}", id.replace(/#/g, '%23')), {
      method: api99FoodAuthorizationUrl.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      // IDs da 99Food são int64 e devem sair do frontend sempre como string.
      body: JSON.stringify({ shopId99Food: normalizedShopId99Food }),
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        if (response.data?.url) {
          setAuthorizationUrl99Food(response.data.url);
          setAtivar99Food1(false);
          setAtivar99Food2(true);
        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message || "Erro ao gerar URL de autorização.");
        setShowToast(true);
        setShowLoading(false);
      });
  }

  function getToken99Food() {
    setShowLoading(true);
    let id = loja;
    const normalizedShopId99Food = normalize99FoodIdString(shopId99Food, "shopId99Food");

    requestService(api99FoodToken.url.replace("{id}", id.replace(/#/g, '%23')), {
      method: api99FoodToken.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify({ shopId99Food: normalizedShopId99Food, empresaid: loja }),
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        setTextToast("Integração 99Food realizada com sucesso.");
        setShowToast(true);
        window.localStorage.setItem("integrado99Food", "true");
        setAtivar99Food2(false);
        getShops99Food();
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message || "Erro ao obter token. Verifique se a autorização foi concedida.");
        setShowToast(true);
        setShowLoading(false);
      });
  }

  function getShops99Food() {
    let id = loja;

    requestService(api99FoodShops.url.replace("{id}", id.replace(/#/g, '%23')), {
      method: api99FoodShops.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        if (response.data) {
          const lojasBase = (Array.isArray(response.data) ? response.data : [response.data]).map((item: any) => map99FoodShopFields(item, item));
          setListaLojas99Food(lojasBase);
          setShowLojas99Food(true);

          // Promise.all(
          //   lojasBase.map(async (item: any) => {
          //     if (!item.appShopId) return item;
          //     const detalhe = await fetch99FoodShopDetailMap(item.appShopId);
          //     return detalhe ? map99FoodShopFields(detalhe, item) : item;
          //   })
          // ).then((lojasDetalhadas) => {
          //   setListaLojas99Food(lojasDetalhadas);
          // });
        }
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message || "Erro ao buscar lojas 99Food.");
        setShowToast(true);
      });
  }

  function getShopDetail99Food(appShopId: string) {
    let id = loja;
    const normalizedAppShopId = normalize99FoodIdString(appShopId, "appShopId");

    requestService(api99FoodShopDetail.url.replace("{id}", id.replace(/#/g, '%23')).concat("?appShopId=", encodeURIComponent(normalizedAppShopId)), {
      method: api99FoodShopDetail.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        if (response.data) {
          setDetalhe99Food(map99FoodShopFields(response.data, { appShopId: normalizedAppShopId }));
          setShowDetalhe99Food(true);
        }
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message || "Erro ao buscar detalhes da loja.");
        setShowToast(true);
      });
  }

  function getDiagnostic99Food() {
    setShowLoading(true);
    let id = loja;

    requestService(api99FoodDiagnostic.url.replace("{id}", id.replace(/#/g, '%23')), {
      method: api99FoodDiagnostic.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        setDiagnostico99Food(response.data || null);
        setShowDiagnostico99Food(true);
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message || "Erro ao gerar diagnóstico 99Food.");
        setShowToast(true);
        setShowLoading(false);
      });
  }

  async function copyDiagnostic99Food() {
    try {
      await navigator.clipboard.writeText(JSON.stringify(diagnostico99Food || {}, null, 2));
      setTextToast("Diagnóstico 99Food copiado.");
      setShowToast(true);
    } catch (error) {
      setTextToast("Nao foi possivel copiar o diagnóstico.");
      setShowToast(true);
    }
  }

  function formatTimestamp99Food(timestamp: number) {
    if (!timestamp) return "Nao informado";
    return new Date(timestamp * 1000).toLocaleString("pt-BR");
  }

  function setShopStatus99Food(appShopId: string, status: number) {
    let id = loja;
    const normalizedAppShopId = normalize99FoodIdString(appShopId, "appShopId");

    requestService(api99FoodSetStatus.url.replace("{id}", id.replace(/#/g, '%23')), {
      method: api99FoodSetStatus.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify({ appShopId: normalizedAppShopId, status }),
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        setTextToast(status === 1 ? "Loja aberta com sucesso." : "Loja fechada com sucesso.");
        setShowToast(true);
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message || "Erro ao alterar status da loja.");
        setShowToast(true);
      });
  }

  function readListaLojas99Food() {
    return (
      <>
        {listaLojas99Food.map((value: any, index: any) => (
          <IonItem
            key={"lojas99food" + (value.appShopId || index)}
            button
            onClick={() => getShopDetail99Food(value.appShopId)}
          >
            <IonLabel>
              <h2>{value.name || value.shopId99Food || "Loja 99Food"}</h2>
              <p>ID da loja 99Food: {value.shopId99Food || "Nao informado"}</p>
            </IonLabel>
          </IonItem>
        ))}
      </>
    );
  }

  function getMerchants() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(apiIfoodMerchants.url.replace("{id}", id.replace(/#/g, '%23')), {
        method: apiIfoodMerchants.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.data) {


            // Verifica se "merchantIdIfood" está armazenado no localStorage
            let merchantId: any = window.localStorage.getItem("merchantIdIfood");

            if (!merchantId) {
              // Caso não esteja definido, verifica se há itens em `listaLojasIfood`
              if (listaLojasIfood && listaLojasIfood.length > 0) {
                // Define o ID do primeiro item da lista no localStorage
                merchantId = listaLojasIfood[0].id;
                window.localStorage.setItem("merchantIdIfood", merchantId);
                console.log("merchantIdIfood definido como:", merchantId);
              } else {
                console.error("A lista de lojas está vazia ou não definida.");
              }
            } else {
              console.log("merchantIdIfood já definido como:", merchantId);
            }



            setListaLojasIfood(response.data);
            setShowLojasIfood(true);

            // window.localStorage.setItem("merchantIdIfood", response.data[0].id);

            // setTextToast("Integração validada com sucesso para empresa " + response.data[0].name + ".");
            // setShowToast(true);
          }

        },
        (error: any) => {
          console.log(error);
          setTextToast(error.message);
          setShowToast(true);
        });

    }

    consultar();
  }

  function getMerchantsDetail() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);
      requestService(apiIfoodMerchantsDetails.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodMerchantsDetails.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.data) {
            setDetalheLojaIfood(response.data);
            setShowDetalheLojaIfood(true);
          }

        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }


  function getMerchantsStatus() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);
      requestService(apiIfoodMerchantsStatus.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodMerchantsStatus.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.data) {
            setStatusLojaIfood(response.data);
            setShowStatusLojaIfood(true);
          }

        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  function getMerchantsInterruptions() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);
      requestService(apiIfoodMerchantsInterruptions.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodMerchantsInterruptions.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.data) {
            setInterruptionsLojaIfood(response.data);
            setShowInterruptionsLojaIfood(true);
          }

        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  function getMerchantsOpenHours() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);
      requestService(apiIfoodMerchantsOpeningHours.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodMerchantsOpeningHours.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.data) {
            setOpenHoursLojaIfood(response.data);
            setShowOpenHoursLojaIfood(true);
          }

        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  function putMerchantsOpenHours() {

    const enviar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);


      let shiftsAlterado = openHoursLojaIfood.shifts.map((item: any) => {
        // Verifica se o item corresponde ao 'dayOfWeek' fornecido
        if (item.id === idOpenHour) {
          // Atualiza o 'start' e 'duration' com os valores fornecidos
          return {
            ...item,
            dayOfWeek: dayOfWeekOpenHour,
            start: startOpenHour,
            duration: durationOpenHour, // Ajusta a duração para 1439 se for 1440
          };
        }
        // Retorna os itens sem alteração se o 'dayOfWeek' não for o mesmo
        return item;
      });

      let params = {
        storeId: window.localStorage.getItem("merchantIdIfood") || "",
        shifts: shiftsAlterado,
      };

      // Verifica se o 'idOpenHour' foi encontrado no array
      const itemExists = openHoursLojaIfood.shifts.some((item: any) => item.id === idOpenHour);

      // Se o item não for encontrado, adiciona um novo item
      if (!itemExists) {
        shiftsAlterado.push({
          id: idOpenHour, // Usando o idOpenHour fornecido para o novo item
          dayOfWeek: dayOfWeekOpenHour,
          start: startOpenHour,
          duration: durationOpenHour, // Ajusta a duração para 1439 se for 1440
        });
      }

      requestService(apiIfoodPutMerchantsOpeningHours.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodPutMerchantsOpeningHours.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(params),
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log("response", response);
          if (response.statusCode == 201 || response.statusCode == 200) {

            setTextToast("Horário alterado com sucesso. Aguarde o processamento.");
            setShowToast(true);
            setShowAlterarHorarioLojaIfood(false);

            setTimeout(() => {
              getMerchantsOpenHours();
            }, 3000);

          }
          else {
            setTextToast("Ocorreu um erro ao processar, verifique as informações e tente novamente.");
            setShowToast(true);
          }

        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    enviar();

  }

  function putMerchantsOpenHoursRemover(idRemover: any) {

    const enviar = async () => {
      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);

      // Filtra o array para remover o item com id igual ao idOpenHour
      let shiftsAlterado = openHoursLojaIfood.shifts.filter((item: any) => item.id !== idRemover);

      // Monta o objeto params com o array alterado
      let params = {
        storeId: window.localStorage.getItem("merchantIdIfood") || "",
        shifts: shiftsAlterado,
      };

      console.log("shiftsAlterado", shiftsAlterado);


      requestService(apiIfoodPutMerchantsOpeningHours.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodPutMerchantsOpeningHours.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(params),
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log("response", response);
          if (response.statusCode == 201 || response.statusCode == 200) {

            setTextToast("Horário removido com sucesso. Aguarde o processamento.");
            setShowToast(true);
            setShowAlterarHorarioLojaIfood(false);

            setTimeout(() => {
              getMerchantsOpenHours();
            }, 3000);

          }
          else {
            setTextToast("Ocorreu um erro ao processar, verifique as informações e tente novamente.");
            setShowToast(true);
          }

        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    enviar();

  }

  function deleteMerchantsInterruptions(interruptionId: any) {

    const enviar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);

      let params = {
        time: selectedTime,
        description: selectedReason
      };

      requestService(apiIfoodDeleteMerchantsInterruptions.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId).replace("{interruptionId}", interruptionId), {
        method: apiIfoodDeleteMerchantsInterruptions.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(params),
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.statusCode == 204) {
            setTextToast("Interrupção excluída com sucesso. Aguarde o processamento.");
            setShowToast(true);

            setTimeout(() => {
              getMerchantsInterruptions();
            }, 3000);

          }
          else {
            setTextToast("Ocorreu um erro ao excluir, verifique as informações e tente novamente.");
            setShowToast(true);
          }



        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    enviar();

  }

  function postMerchantsInterruptions() {

    const enviar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);

      let params = {
        time: selectedTime,
        description: selectedReason
      };

      requestService(apiIfoodPostMerchantsInterruptions.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodPostMerchantsInterruptions.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(params),
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.statusCode == 201 || response.statusCode == 200) {
            setTextToast("Interrupção realizada com sucesso. Aguarde o processamento.");
            setShowToast(true);
            setTimeout(() => {
              getMerchantsInterruptions();
            }, 3000);

            setShowFecharLojaIfood(false);
          }
          else {
            setTextToast("Ocorreu um erro ao processar, verifique as informações e tente novamente.");
            setShowToast(true);
          }

        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    if (!selectedTime) {
      setTextToast("Tempo é obrigatório para fechar a loja.");
      setShowToast(true);
    }
    else if (!selectedReason) {
      setTextToast("Motivo é obrigatório para fechar a loja.");
      setShowToast(true);
    }
    else {
      enviar();
    }

  }

  function postMerchantsInterruptionsPausa() {

    const enviar = async () => {
      // Verificar se todos os campos estão preenchidos
      if (!startDate || !startTime || !endDate || !endTime || !pauseTitle) {
        // Caso algum campo esteja vazio, exibir mensagem de erro
        setTextToast("Todos os campos são obrigatórios.");
        setShowToast(true);
        return; // Interromper o envio caso algum campo não esteja preenchido
      }

      console.log("aasasasasa", loja);
      let id = loja;
      let merchantId = window.localStorage.getItem("merchantIdIfood") || "";
      console.log("aasasasasa", merchantId);

      // Extração da data do início
      const extractedStartDate = new Date(startDate).toISOString().split("T")[0]; // "2024-12-04"
      // Combinar data e hora do início em um único formato ISO 8601 com fuso horário
      const startDateTime = `${extractedStartDate}T${startTime}`; // "2024-12-04T15:58:00-03:00"

      // Extração da data do término
      const extractedEndDate = new Date(endDate).toISOString().split("T")[0]; // "2024-12-04"
      // Combinar data e hora do término em um único formato ISO 8601 com fuso horário
      const endDateTime = `${extractedEndDate}T${endTime}`; // "2024-12-04T16:58:00-03:00"

      console.log("startDateTime", startDateTime);

      // Preencher o objeto params corretamente
      const params = {
        description: pauseTitle, // Título da pausa
        start: startDateTime,    // Início completo no formato ISO 8601
        end: endDateTime,        // Término completo no formato ISO 8601
      };

      // Realizar a requisição
      requestService(apiIfoodPostMerchantsInterruptions.url.replace("{id}", id.replace(/#/g, '%23')).replace("{merchantId}", merchantId), {
        method: apiIfoodPostMerchantsInterruptions.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(params),
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          if (response.statusCode == 201 || response.statusCode == 200) {
            setTextToast("Interrupção realizada com sucesso. Aguarde o processamento.");
            setShowToast(true);
            setTimeout(() => {
              getMerchantsInterruptions();
            }, 3000);

            setShowPausaProgramada(false);
          } else {
            setTextToast("Ocorreu um erro ao processar, verifique as informações e tente novamente.");
            setShowToast(true);
          }
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });
    };

    enviar();

  }


  function getTerminals() {

    const consultar = async () => {

      console.log("aasasasasa", loja);



      let id = loja;
      requestService(apiMercadoPagoTerminals.url.replace("{id}", id.replace(/#/g, '%23')) + "?empresaId=" + encodeURIComponent(id), {
        method: apiMercadoPagoTerminals.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response.data);

          const terminals = response?.data?.data?.terminals;

          if (Array.isArray(terminals) && terminals.length > 0) {
            setListaMercadoPagoTerminals(terminals);
            setMercadoPago1(false);
            setMercadoPago2(true);
          } else {
            setTextToast("Ocorreu um erro ao processar. Verifique as informações e tente novamente.");
            setShowToast(true);
          }


        },
        (error: any) => {
          console.log(error);
          setTextToast("Ocorreu um erro ao processar, verifique as informações e tente novamente.");
          setShowToast(true);
        });

    }

    consultar();
  }


  function patchOperationMode(deviceId: any, mode: any) {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;


      let params = {
        terminals: [
          {
            id: deviceId,
            operating_mode: mode
          }
        ]
      };

      requestService(apiMercadoPagoOperationMode.url + "?empresaId=" + encodeURIComponent(id), {
        method: apiMercadoPagoOperationMode.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(params),
        credentials: 'include'
      },
        history,
        async (response: any) => {
          console.log(response.data);

          if (response.data.terminals) {
            setTextToast("Alteração realizada com sucesso.");
            setShowToast(true);
            setListaMercadoPagoTerminals((terminaisAtuais: any[]) => terminaisAtuais.map((terminal: any) =>
              terminal.id === deviceId
                ? { ...terminal, operating_mode: mode }
                : terminal
            ));
          }
          else {
            setTextToast("Ocorreu um erro ao processar, verifique as informações e tente novamente.");
            setShowToast(true);
          }

        },
        (error: any) => {
          console.log(error);
          setTextToast("Ocorreu um erro ao processar, verifique as informações e tente novamente.");
          setShowToast(true);
        });

    }

    consultar();
  }

  const generateTimeOptions2359 = () => {
    const times = [];
    let hour = 0;
    let minute = 0;

    // Gera opções de hora no formato HH:mm:ss, de 30 em 30 minutos
    for (let i = 0; i < 48; i++) {
      const hourStr = hour < 10 ? `0${hour}` : `${hour}`;
      const minuteStr = minute < 10 ? `0${minute}` : `${minute}`;
      times.push(`${hourStr}:${minuteStr}:00`);

      // Incrementa os minutos em 30
      minute += 30;
      if (minute === 60) {
        minute = 0;
        hour += 1;
      }
    }

    // Adiciona a última opção de horário como "23:59"
    times.push("23:59:00");

    return times;
  };

  const generateDurationOptions = () => {
    const durations = [];
    let duration = 30; // Começando com 30 minutos
    while (duration <= 1439) { // Limite máximo de 1439 minutos (23h59)
      durations.push(duration);
      duration += 30; // Incrementa de 30 em 30 minutos
    }

    // Adiciona explicitamente 23:59:00
    durations.push(1439); // 1439 minutos correspondem a 23:59

    return durations;
  };


  const formatDuration = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    // Se for 0 horas, retorna apenas os minutos
    if (hours === 0 && mins > 0) {
      return `${mins} minutos`;
    }

    // Se for 0 minutos, retorna apenas as horas
    if (mins === 0 && hours > 0) {
      return `${hours} horas`;
    }

    // Se ambos forem diferentes de 0, retorna as horas e minutos
    return `${hours} horas e ${mins} minutos`;
  };


  const handleDurationChange = (duration: number) => {
    console.log("duration", duration);
    setDurationOpenHour(duration);

    if (startOpenHour) {
      const [startHour, startMinute] = startOpenHour.split(':').map(Number);
      const startTotalMinutes = startHour * 60 + startMinute;

      const endTotalMinutes = startTotalMinutes + duration;

      // Verifica se o cálculo da duração gera um valor negativo
      console.log("startTotalMinutes", startTotalMinutes);
      console.log("endTotalMinutes", endTotalMinutes);
      // Verifica se o total de minutos ultrapassa 1440 minutos (24 horas)
      if (endTotalMinutes > 1439) {
        setDurationOpenHour(0);
        setTextToast("A duração não pode ultrapassar 23:59 horas. Verifique as informações e tente novamente.");
        setShowToast(true);
      }
    }
  };

  function converterParaString(dadosImpressao: any) {
    return String.fromCharCode(...dadosImpressao.filter((byte: any) => byte <= 0xFF)); // Filtrando valores válidos
  }

  async function enviarImpressao(printer: any, data: any) {

    const url = "http://localhost:9100/print";

    // Montando o corpo da requisição no formato necessário
    var raw = JSON.stringify({
      "printer": printer,
      "data": data,  // Dados no formato correto (com códigos ESC/POS)
    });

    try {
      // Configurações da requisição
      const requestOptions: any = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: 'follow',
      };

      // Envia a requisição utilizando fetch
      const resp = await fetch(url, requestOptions);

      // Aguardar a resposta como texto
      const result = await resp.text();

      if (result) {
        console.log("Impressão enviada com sucesso:", result);
      } else {
        console.error("Erro: Nenhuma resposta recebida.");
      }
    } catch (error) {
      console.error("Erro ao enviar dados para a impressora:", error);
    }
  }

  const ativarWhatsappWeb = async () => {

    if (onboardingData && !onboardingData.onboarding_concluido) {
      const urlOnb = onboardingAtualizarEtapa.url
        .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
      requestService(urlOnb, {
        method: onboardingAtualizarEtapa.method,
        body: JSON.stringify({ etapa_id: 'robozinho', status: 'concluido' }),
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
    }

    // Garante que o bot esteja iniciado antes do polling do QR (idempotente).
    // "Já inicializado" não é erro: significa que o bot já está rodando, e o
    // cliente ainda precisa escanear o QR para conectar. Por isso seguimos
    // sempre para o modal/polling, independente do resultado do /start.
    const idLoja = loja;
    const continuar = () => iniciarFluxoQrCode();
    requestService(apiWhatsappWebStart.url.replace("{id}", idLoja.replaceAll(/#/g, '%23')), {
      method: apiWhatsappWebStart.method,
      headers: [["token", window.localStorage.getItem("token")]],
      credentials: 'include'
    },
      history,
      continuar,
      continuar
    );
  }

  const iniciarFluxoQrCode = () => {
    generateQRCode();

    qrPollingIntervalRef.current = setInterval(() => {
      generateQRCode();
    }, 3000);

    qrPollingTimeoutRef.current = setTimeout(() => {
      stopQrPolling();
      setAtivarWhatsapp1(false);
    }, 20000);
  }

  const generateQRCode = async () => {
    try {


      const consultar = async () => {

        console.log("aasasasasa", loja);
        let id = loja;

        requestService(apiWhatsappWebQrcode.url.replace("{id}", id.replaceAll(/#/g, '%23')), {
          method: apiWhatsappWebQrcode.method,
          headers: [
            ["token", window.localStorage.getItem("token")]
          ],
          credentials: 'include'
        },
          history,
          async (response: any) => {
            console.log(response.message);
            if (response?.message?.qr) {
              setAtivarWhatsapp1(true);
              const qrData = await QRCode.toDataURL(response.message.qr);
              setQRCodeData(qrData);
            } else {
              // 200 sem qr => bot conectou
              stopQrPolling();
              setAtivarWhatsapp1(false);
              setTextToast('WhatsApp Web ativado com sucesso. Para encerrar o robô, desconecte o dispositivo no WhatsApp do seu celular.');
              setShowToast(true);
            }
            setShowLoading(false);
          },
          (error: any) => {
            console.log(error);
            // Conectou: para o polling, fecha o modal e marca como ativo.
            stopQrPolling();
            setAtivarWhatsapp1(false);
            setTextToast('WhatsApp Web ativado com sucesso. Para encerrar o robô, desconecte o dispositivo no WhatsApp do seu celular.');
            setShowToast(true);
            setShowLoading(false);
          });

      }

      consultar();

    } catch (err) {
      console.error('Erro ao gerar o QR Code', err);
    }
  };


  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">


          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>

          <IonTitle slot="start">Integrações</IonTitle>
        </IonToolbar>
        <OnboardingContextBanner />
      </IonHeader>
      <IonContent className="ion-text-center" fullscreen>
        <IonGrid>
          <IonRow>

            {/* {exibirCardWhatsappOficial && <IonCol size="12" sizeMd="6" sizeLg="6">
              <IonCard style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column" }}>
                <IonCardHeader style={{ flex: "0 0 auto" }}>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                    <IonIcon
                      icon={logoWhatsapp}
                      color="success"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                  <IonCardTitle>WhatsApp Oficial</IonCardTitle>
                  <IonCardSubtitle>Meta Cloud API</IonCardSubtitle>
                </IonCardHeader>

                <IonCardContent style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ marginBottom: "20px" }}>
                      Use a integração oficial para automatizar seu atendimento.
                    </p>
                  </div>
                  <div className="integracoes-whatsapp-actions">
                    <WhatsAppMetaCard empresaId={loja} />
                    <IonButton fill="clear" className="integracoes-whatsapp-attendance" onClick={() => {
                      abrirModalConfiguracaoRobo();
                    }}>
                      Configurar atendimento
                    </IonButton>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>} */}

            {/* O WhatsApp Web legado fica oculto quando o WhatsApp Oficial está habilitado na conta. */}
            {exibirCardRobozinho && <IonCol size="12" sizeMd="6" sizeLg="6">
              <IonCard style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column" }}>
                <IonCardHeader style={{ flex: "0 0 auto" }}>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                    <IonImg
                      src={iconRobo}
                      alt="Robozinho"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                  <IonCardTitle>Robozinho</IonCardTitle>
                  <IonCardSubtitle>WhatsApp</IonCardSubtitle>
                </IonCardHeader>

                <IonCardContent style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ marginBottom: "20px" }}>
                      Automatize seu atendimento no delivery.
                    </p>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginTop: "auto", paddingTop: "10px" }}>
                    {exibirCardWhatsappOficial && <WhatsAppMetaCard empresaId={loja} />}
                    <IonButton size="large" onClick={() => {
                      ativarWhatsappWeb();
                    }}>
                      WhatsApp Web
                    </IonButton>
                    <IonButton size="large" onClick={() => {
                      abrirModalConfiguracaoRobo();
                    }}>
                      Configurar
                    </IonButton>

                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>}

            {/* Card PIX automático */}
            <IonCol size="12" sizeMd="6" sizeLg="6">
              <IonCard style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column" }}>
                <IonCardHeader style={{ flex: "0 0 auto" }}>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                    <IonImg
                      src={iconPixAutomatizado}
                      alt="Mercado Pago"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                  <IonCardTitle>PIX Automatizado</IonCardTitle>
                  <IonCardSubtitle>Pagamentos</IonCardSubtitle>
                </IonCardHeader>

                <IonCardContent style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ marginBottom: "20px" }}>
                      Receba seus pedidos online de forma rápida e prática.
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "auto", paddingTop: "10px" }}>
                    <IonButton size="large" onClick={() => {
                      setShowModalPixAutomatizado(true);
                    }}>
                      Ativar
                    </IonButton>
                    {/* <IonButton size="large" onClick={() => {
                      getTerminals();
                    }}>
                      Detalhes
                    </IonButton> */}
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

            {/* Card 99Food */}
            <IonCol size="12" sizeMd="6" sizeLg="6">
              <IonCard style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column" }}>
                <IonCardHeader style={{ flex: "0 0 auto" }}>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                    <IonImg
                      src={icon99Food}
                      alt="99Food"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                  <IonCardTitle>99Food</IonCardTitle>
                  <IonCardSubtitle>Marketplace</IonCardSubtitle>
                </IonCardHeader>

                <IonCardContent style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ marginBottom: "20px" }}>
                      Receba pedidos do 99Food diretamente no seu painel.
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "auto", paddingTop: "10px" }}>
                    <IonButton size="large" onClick={() => {
                      setAtivar99Food1(true);
                    }}>
                      Ativar
                    </IonButton>
                    <IonButton size="large" onClick={() => {
                      getShops99Food();
                    }}>
                      Detalhes
                    </IonButton>
                    {/* <IonButton size="large" fill="outline" onClick={() => {
                      getDiagnostic99Food();
                    }}>
                      Diagnóstico
                    </IonButton> */}
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

            {/* Card Mercado Pago */}
            <IonCol size="12" sizeMd="6" sizeLg="6">
              <IonCard style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column" }}>
                <IonCardHeader style={{ flex: "0 0 auto" }}>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                    <IonImg
                      src={iconMercadopago}
                      alt="Mercado Pago"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                  <IonCardTitle>Mercado Pago</IonCardTitle>
                  <IonCardSubtitle>Pagamentos</IonCardSubtitle>
                </IonCardHeader>

                <IonCardContent style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ marginBottom: "20px" }}>
                      Receba pagamentos facilmente no PDV via Mercado Pago.
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "auto", paddingTop: "10px" }}>
                    <IonButton size="large" onClick={abrirAtivacaoMercadoPago}>
                      {mercadoPagoConfigurado ? "Atualizar credencial" : "Ativar"}
                    </IonButton>
                    <IonButton size="large" onClick={() => {
                      getTerminals();
                    }}>
                      Detalhes
                    </IonButton>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>


            {/* Card iFood */}
            <IonCol size="12" sizeMd="6" sizeLg="6">
              <IonCard style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column" }}>
                <IonCardHeader style={{ flex: "0 0 auto" }}>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                    <IonImg
                      src={iconIfood}
                      alt="iFood"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                  <IonCardTitle>iFood</IonCardTitle>
                  <IonCardSubtitle>Marketplace</IonCardSubtitle>
                </IonCardHeader>

                <IonCardContent style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ marginBottom: "20px" }}>
                      Automatize os pedidos recebidos no delivery.
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "auto", paddingTop: "10px" }}>
                    <IonButton size="large" onClick={() => {
                      getUserCode();
                      setAtivarIfood1(true);
                    }}>
                      Ativar
                    </IonButton>
                    <IonButton size="large" onClick={() => {
                      getMerchants();
                    }}>
                      Detalhes
                    </IonButton>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>


            <IonCol size="12" sizeMd="6" sizeLg="6">
              <IonCard style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column" }}>

                <IonCardHeader style={{ flex: "0 0 auto" }}>
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                    <IonImg
                      src={iconRegistroBr}
                      alt="Registro .br"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                  <IonCardTitle>Domínio .br</IonCardTitle>
                  <IonCardSubtitle>Registro de domínio</IonCardSubtitle>
                </IonCardHeader>



                <IonCardContent style={{ flex: "1", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ marginBottom: "20px" }}>
                      Verifique a disponibilidade do seu domínio .br e prossiga com a contratação.
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "auto", paddingTop: "10px" }}>
                    <IonButton size="large" onClick={() => setShowModalDominio(true)}>
                      Ativar
                    </IonButton>
                  </div>
                </IonCardContent>


              </IonCard>
            </IonCol>

            {/* Meta Ads (Facebook + Instagram) */}
            <IntegrationCard
              icone={iconMetaAds}
              iconeAlt="Meta Ads"
              titulo="Meta Ads"
              categoria="Marketing"
              descricao="Integre Facebook e Instagram Ads para rastrear conversões e melhorar suas campanhas."
              ativo={metaAdsAtivo}
              onAtivar={() => setShowModalMetaAds(true)}
            />

            {/* Google Analytics 4 */}
            <IntegrationCard
              icone={iconGoogleAnalytics}
              iconeAlt="Google Analytics"
              titulo="Google Analytics"
              categoria="Analytics"
              descricao="Acompanhe acessos, pedidos e comportamento dos clientes em tempo real."
              ativo={analyticsAtivo}
              onAtivar={() => setShowModalAnalytics(true)}
            />
          </IonRow>
        </IonGrid>

        <IntegracaoMetaAdsModal
          isOpen={showModalMetaAds}
          onDidDismiss={() => setShowModalMetaAds(false)}
          loja={loja}
          onStatusChange={(ativo) => setMetaAdsAtivo(ativo)}
        />

        <IntegracaoAnalyticsModal
          isOpen={showModalAnalytics}
          onDidDismiss={() => setShowModalAnalytics(false)}
          loja={loja}
          onStatusChange={(ativo) => setAnalyticsAtivo(ativo)}
        />

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        {/* Modal de consulta de domínio .br (nível superior) */}
        <IonModal isOpen={showModalDominio} onDidDismiss={() => setShowModalDominio(false)}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="start">
                <IonButton onClick={() => setShowModalDominio(false)}>
                  <IonIcon slot="icon-only" icon={arrowBack} />
                </IonButton>
              </IonButtons>
              <IonTitle>Consultar Domínio .br</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonGrid>
              {/* Bloco informativo no padrão do exemplo (vantagens e condições) */}
              <IonRow class="ion-justify-content-center ion-text-center">
                <IonCol size="12">
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
                    <IonImg src={iconRegistroBr} alt="Registro .br" style={{ width: 80, height: 80 }} />
                  </div>
                  <div style={{ lineHeight: 1.5 }}>
                    <p>
                      Com o <b>Domínio .br</b>, sua empresa terá um endereço profissional na internet, aumentando a
                      credibilidade da marca e a presença digital.
                    </p>

                    <p style={{ marginTop: 12 }}>
                      <b>Valor:</b> R$ 99,90 por ano
                      <br />
                      <b>Disponibilidade:</b> sujeita à consulta no Registro.br
                      <br />
                      <b>Ativação:</b> após confirmação do pagamento
                      <br />
                      <b>Renovação:</b> anual
                    </p>
                    <p style={{ marginTop: 12 }}>
                      Para prosseguir, informe o domínio desejado e clique em <b>Verificar disponibilidade</b> para verificar a disponibilidade.
                    </p>
                  </div>
                </IonCol>
              </IonRow>

              <IonRow>
                <IonCol size="12">
                  {/* <IonLabel>Domínio desejado</IonLabel> */}
                  <IonInput
                    style={{
                      textAlign: 'center',
                      fontSize: '24px',
                      fontWeight: 'bold',
                      color: '#7D7D7D',
                      border: '1px solid #E0E0E0',
                      borderRadius: '8px',
                      padding: '12px',
                      margin: '0 auto',
                      maxWidth: '320px'
                    }}
                    placeholder="ex: xeguei.com.br"
                    value={dominioConsulta}
                    onIonChange={(e: any) => setDominioConsulta(e.target.value)}
                    clearInput
                  />
                </IonCol>
              </IonRow>

            </IonGrid>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={validarDominioBr}>
              Verificar disponibilidade
            </IonButton>

          </IonFooter>
        </IonModal>

        <IonModal isOpen={showModalConfiguracaoRobo} onDidDismiss={cancelarConfiguracaoRobo}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="start">
                <IonButton onClick={cancelarConfiguracaoRobo}>
                  <IonIcon slot="icon-only" icon={arrowBack} />
                </IonButton>
              </IonButtons>
              <IonTitle>Configurar robô</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding integracoes-modal-content">
            <IonCard className="integracoes-card">
              <IonCardContent>
                <div className="integracoes-section-header">
                  <IonLabel>
                    <div className="integracoes-title-row">
                      <h2>Tipo de robô</h2>
                      <InfoIntegracao triggerId="info-robo-tipo-robo">
                        <p><strong>Robô simples:</strong> quando o cliente entra em contato, é enviado um link para acessar o cardápio digital.</p>
                        <p><strong>Robô com IA:</strong> interage com o cliente sobre as informações da empresa, sempre direcionando para o cardápio digital para converter em venda.</p>
                        <p>Ambos enviam informações do pedido realizado e mensagens quando o status do pedido é alterado.</p>
                      </InfoIntegracao>
                    </div>
                    <IonNote>Atenda no automático com o robô simples ou com IA</IonNote>
                  </IonLabel>
                  <IonBadge color="primary">{tipoRoboLabel}</IonBadge>
                </div>
              </IonCardContent>
            </IonCard>

            <IonCard className="integracoes-card">
              <IonCardContent>
                <div className="integracoes-section-title">
                  <div className="integracoes-title-row">
                    <h2>Modo de resposta do robô</h2>
                    <InfoIntegracao triggerId="info-robo-modo-resposta">
                      <p><strong>Enviar telefone:</strong> quando o cliente quiser falar com alguém, o robô informa o telefone da empresa.</p>
                      <IonNote className="integracoes-popover-example">
                        Nosso atendimento automático está funcionando, mas se quiser falar com alguém, é só ligar: 5599999999999
                      </IonNote>
                      <p><strong>Aguardar atendimento:</strong> quando o cliente quiser falar com alguém, o robô informa que ele deve aguardar para ser atendido.</p>
                      <IonNote className="integracoes-popover-example">
                        Nosso atendimento automático está funcionando, mas se quiser falar com alguém, aguarde para ser atendido.
                      </IonNote>
                    </InfoIntegracao>
                  </div>
                </div>

                <IonList className="integracoes-list">
                  <IonRadioGroup value={modoFallbackRobo} onIonChange={(e: any) => setModoFallbackRobo((e.detail.value || '') as ModoFallbackRobo)}>
                    <IonItem lines="full" className="integracoes-option">
                      <IonLabel className="ion-text-wrap">
                        <div className="integracoes-title-row">
                          <h3>Enviar telefone</h3>
                        </div>
                        <IonNote>Informa o telefone cadastrado da empresa.</IonNote>
                      </IonLabel>
                      <IonRadio slot="end" value="" />
                    </IonItem>

                    <IonItem lines="none" className="integracoes-option">
                      <IonLabel className="ion-text-wrap">
                        <div className="integracoes-title-row">
                          <h3>Aguardar atendimento</h3>
                        </div>
                        <IonNote>Orienta o cliente a aguardar o atendimento.</IonNote>
                      </IonLabel>
                      <IonRadio slot="end" value="aguardar_atendimento" />
                    </IonItem>
                  </IonRadioGroup>
                </IonList>
              </IonCardContent>
            </IonCard>

            <IonCard className="integracoes-card">
              <IonCardContent>
                <div className="integracoes-section-header">
                  <IonLabel>
                    <div className="integracoes-title-row">
                      <h2>Intervalo de interrupção</h2>
                      <InfoIntegracao triggerId="info-robo-intervalo-interrupcao">
                        <p>Quando a loja assume o atendimento (envia uma mensagem manual), o robô fica em silêncio por esse período antes de voltar a responder automaticamente.</p>
                        <p>
                          O valor é em minutos. Se não for configurado, o padrão é <strong>10 minutos</strong>.
                        </p>
                      </InfoIntegracao>
                    </div>
                    <IonNote>Tempo em minutos que o robô aguarda após uma interrupção da loja.</IonNote>
                  </IonLabel>
                  <div className="integracoes-intervalo-control">
                    <IonInput
                      className="integracoes-input-interrupcao"
                      type="number"
                      inputmode="numeric"
                      min={1}
                      max={1440}
                      value={intervaloInterrupcaoRoboMinutos}
                      aria-label="Intervalo de interrupção em minutos"
                      onIonInput={(e: any) => setIntervaloInterrupcaoRoboMinutos(Number(e.target.value))}
                      onIonBlur={(e: any) => setIntervaloInterrupcaoRoboMinutos(normalizarIntervaloInterrupcao(e.target.value))}
                    />
                    <span>min</span>
                  </div>
                </div>
              </IonCardContent>
            </IonCard>

            <IonCard className="integracoes-card">
              <IonCardContent>
                <IonItem lines="none" className="integracoes-toggle-item">
                  <IonLabel className="ion-text-wrap">
                    <div className="integracoes-title-row">
                      <h2>Recuperador de vendas</h2>
                      <InfoIntegracao triggerId="info-robo-recuperador-vendas">
                        <p>Se o cliente entrar em contato e não finalizar a compra pelo cardápio digital em até 15 minutos, o sistema envia automaticamente uma mensagem para recuperar a venda. Caso tenha cupom de desconto disponível, ele será enviado automaticamente.</p>
                        <IonNote className="integracoes-popover-example">
                          {"Bateu aquela fome? 😊\n\nSe ainda não finalizou seu pedido, estamos te aguardando 😋\n\n👉 https://sua-loja.xeguei.com.br/"}
                        </IonNote>
                      </InfoIntegracao>
                    </div>
                    <IonNote>Envia uma mensagem automática quando o pedido não é finalizado.</IonNote>
                  </IonLabel>
                  <IonToggle slot="end" checked={recuperadorVendasAtivo} onIonChange={(e: any) => setRecuperadorVendasAtivo(e.detail.checked)} />
                </IonItem>
              </IonCardContent>
            </IonCard>
          </IonContent>
          <IonFooter>
            <IonGrid>
              <IonRow>
                <IonCol>
                  <IonButton expand="block" color="primary" disabled={salvandoConfiguracaoRobo} onClick={salvarConfiguracaoRobo}>
                    Salvar
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={ativarWhatsapp1} onDidDismiss={() => { stopQrPolling(); setAtivarWhatsapp1(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>WhatsApp Web</IonTitle>
              <IonButtons slot="start" onClick={() => setAtivarWhatsapp1(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
              <IonItem lines="none" style={{ justifyContent: "center" }}>
                <img style={{ width: '80px', borderRadius: '5px' }} src={logoWhatsapp} alt="whatsapp icon" />
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Acessar WhatsApp Web
                </div>
              </IonItem>
              {/* <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>
                  Use o WhatsApp no seu navegador para enviar mensagens privadas para seus amigos e familiares.
                </div>
              </IonItem> */}

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "left" }}>
                <div style={{ maxWidth: "600px" }}>
                  <p><strong>1.</strong> Abra o WhatsApp no seu celular.</p>
                  <p><strong>2.</strong> Toque em <strong>Mais opções</strong> <span style={{ fontSize: "18px" }}>⋮</span> no Android ou em <strong>Configurações</strong> <span style={{ fontSize: "18px" }}>⚙️</span> no iPhone</p>
                  <p><strong>3.</strong> Toque em <strong>Dispositivos conectados</strong> e, em seguida, em <strong>Conectar dispositivo</strong>.</p>
                  <p><strong>4.</strong> Aponte seu celular para esta tela para escanear o QR code.</p>
                </div>
              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "left" }}>

                <div className="div-qrcode">
                  <div className="qr-code">
                    {qrCodeData && <img src={qrCodeData} alt="QR Code" />}
                  </div>
                </div>




              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>
                  <a target="_blank" href="https://faq.whatsapp.com/1317564962315842/?cms_platform=web&lang=pt-BR" style={{ textDecoration: "underline", color: "#2e8b57" }}>Precisa de ajuda para começar?</a>
                </div>
              </IonItem>
            </IonList>

          </IonContent>

        </IonModal>

        <IonModal isOpen={ativarIfood1} onDidDismiss={() => { setAtivarIfood1(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração iFood</IonTitle>
              <IonButtons slot="start" onClick={() => setAtivarIfood1(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
              <IonItem lines="none" style={{ justifyContent: "center" }}>
                <img style={{ width: '120px', borderRadius: '5px' }} src={iconIfood} alt="iFood icon" />
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Ao integrar, os pedidos do iFood irão aparecer em {window.localStorage.getItem("servicoTipoPlural") || "Projetos"}
                </div>
              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>
                  Copie o código abaixo e cole no portal do parceiro:
                </div>




              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>


                  <IonInput
                    style={{
                      textAlign: "center",
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#7D7D7D",
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "12px"
                    }}
                    value={userCode}
                    readonly
                  />

                  <IonButton fill="clear" onClick={() => {
                    navigator.clipboard.writeText(userCode);
                    setTextToast("Código copiado com sucesso.");
                    setShowToast(true);
                  }}>
                    <IonIcon color="primary" icon={copy} /> copiar
                  </IonButton>
                </div>
              </IonItem>
              <IonItem lines="none" style={{ textAlign: "center", justifyContent: "center" }}>
                <div>
                  Ou clique em: <a
                    href={`https://portal.ifood.com.br/apps/code?c=${userCode}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setTimeout(() => {
                        setAtivarIfood1(false);
                        setAtivarIfood2(true);
                      }, 1000);
                    }}
                  >
                    https://portal.ifood.com.br/apps/code?c={userCode}
                  </a>
                </div>
              </IonItem>
            </IonList>

          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {
              setAtivarIfood1(false);
              setAtivarIfood2(true);
            }}>Avançar</IonButton>
          </IonFooter>

        </IonModal>

        <IonModal isOpen={ativarIfood2} onDidDismiss={() => { setAtivarIfood2(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração iFood</IonTitle>
              <IonButtons slot="start" onClick={() => setAtivarIfood2(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
              <IonItem lines="none" style={{ justifyContent: "center" }}>
                <img style={{ width: '200px', borderRadius: '5px' }} src={iconIfood} alt="iFood icon" />
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Agora, copie o código no portal do parceiro gerado do iFood e cole abaixo:
                </div>
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", width: "100%", maxWidth: "300px" }}>
                <IonInput
                  style={{
                    textAlign: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#7D7D7D",
                    border: "1px solid #E0E0E0",
                    borderRadius: "8px",
                    padding: "12px"
                  }}
                  value={authorizationCode}
                  onIonInput={(e: any) => setAuthorizationCode(e.target.value)}
                  placeholder='AAAA-AAAA'
                />

              </IonItem>

            </IonList>

          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {

              getTokenIfood();

            }}>Integrar</IonButton>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={showLojasIfood} onDidDismiss={() => { setShowLojasIfood(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração iFood</IonTitle>
              <IonButtons slot="start" onClick={() => setShowLojasIfood(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListalojasIfood()}
            </IonList>
          </IonContent>

          {/* <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {
              setShowLojasIfood(false);
            }}>Remover integrações</IonButton>
          </IonFooter> */}
        </IonModal>

        <IonModal isOpen={showDetalheLojaIfood} onDidDismiss={() => { setShowDetalheLojaIfood(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Detalhes - Integração iFood</IonTitle>
              <IonButtons slot="start" onClick={() => setShowDetalheLojaIfood(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {detalheLojaIfood && (
              <>
                <IonCard>
                  {/* <IonCardHeader>
                    <IonCardTitle>{detalheLojaIfood.name}</IonCardTitle>
                    <IonCardSubtitle>{detalheLojaIfood.corporateName}</IonCardSubtitle>
                  </IonCardHeader> */}
                  <IonCardContent>
                    <IonList>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>{detalheLojaIfood.name}</h3>
                          <p>{detalheLojaIfood.corporateName}</p>

                        </IonLabel>
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Endereço</h3>
                          <p>{detalheLojaIfood.address.street}, {detalheLojaIfood.address.number}</p>
                          <p>{detalheLojaIfood.address.city}, {detalheLojaIfood.address.state} - {detalheLojaIfood.address.country}</p>
                          <p>CEP: {detalheLojaIfood.address.postalCode}</p>
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Latitude / Longitude</h3>
                          <p>{detalheLojaIfood.address.latitude}, {detalheLojaIfood.address.longitude}</p>
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Ticket Médio</h3>
                          <p>R$ {detalheLojaIfood.averageTicket.toFixed(2)}</p>
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Status</h3>
                          <p>{detalheLojaIfood.status}</p>
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Operações</h3>
                          {detalheLojaIfood.operations?.map((op: any, index: any) => (
                            <p key={index}>{op.name}</p>
                          ))}
                        </IonLabel>
                      </IonItem>
                    </IonList>
                  </IonCardContent>
                </IonCard>
              </>
            )}
          </IonContent>

          {/* <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => setShowLojasIfood(false)}>
              Desativar integração
            </IonButton>
          </IonFooter> */}
        </IonModal>

        <IonModal isOpen={showStatusLojaIfood} onDidDismiss={() => { setShowStatusLojaIfood(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Status - Integração iFood</IonTitle>
              <IonButtons slot="start" onClick={() => setShowStatusLojaIfood(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {statusLojaIfood && Array.isArray(statusLojaIfood) && statusLojaIfood?.map((item: any, index: any) => (
              <IonCard key={index}>
                {/* <IonCardHeader>
                  <IonCardTitle>{item.message?.title}</IonCardTitle>
                  <IonCardSubtitle>{item.message?.subtitle}</IonCardSubtitle>
                </IonCardHeader> */}
                <IonCardContent>
                  <IonList>
                    {/* <IonItem>
                      <IonLabel>
                        <h3>Operação</h3>
                        <p>{item.operation || "Não especificado"}</p>
                      </IonLabel>
                    </IonItem>
                    <IonItem>
                      <IonLabel>
                        <h3>Canal de Venda</h3>
                        <p>{item.salesChannel || "Não especificado"}</p>
                      </IonLabel>
                    </IonItem>
                    <IonItem>
                      <IonLabel>
                        <h3>Disponível</h3>
                        <p>{item.available ? "Sim" : "Não"}</p>
                      </IonLabel>
                    </IonItem>
                    <IonItem>
                      <IonLabel>
                        <h3>Estado</h3>
                        <p>{item.state || "Não especificado"}</p>
                      </IonLabel>
                    </IonItem>
                    <IonItem>
                      <IonLabel>
                        <h3>Reabertura Permitida</h3>
                        <p>{item.reopenable?.reopenable ? "Sim" : "Não"}</p>
                      </IonLabel>
                    </IonItem> */}

                    <IonItem lines="none">
                      <IonLabel>
                        <h3>{item.message?.title}</h3>
                        <p>{item.message?.subtitle}</p>
                      </IonLabel>
                    </IonItem>
                    {item.validations?.length > 0 && (
                      <>
                        {
                          item.validations.map((validation: any, idx: any) => (
                            <div key={idx}>
                              <IonItem lines="none">
                                <IonLabel>
                                  <h3>{validation.message?.title}</h3>
                                  <p>{validation.message?.subtitle}</p>
                                </IonLabel>
                              </IonItem>


                            </div>
                          ))
                        }
                      </>
                    )}
                  </IonList>
                </IonCardContent>
              </IonCard>
            ))}
          </IonContent>

          {/* <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => setShowFecharLojaIfood(true)}>
              Fechar Loja
            </IonButton>
          </IonFooter> */}
        </IonModal>

        <IonModal isOpen={showInterruptionsLojaIfood} onDidDismiss={() => { setShowInterruptionsLojaIfood(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Interrupções - Integração iFood</IonTitle>
              <IonButtons slot="start" onClick={() => setShowInterruptionsLojaIfood(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {/* <IonFab vertical="top" horizontal="end" slot="fixed">
              <IonFabButton color="tertiary" onClick={() => { getMerchantsInterruptions(); }} >
                <IonIcon color="light" icon={refresh}></IonIcon>
              </IonFabButton>
            </IonFab> */}
            {interruptionsLojaIfood && Array.isArray(interruptionsLojaIfood) && interruptionsLojaIfood.map((item: any, index: any) => (
              <IonCard key={index}>
                <IonCardContent>
                  <IonList>
                    <IonItem lines="none">
                      <IonLabel>
                        <h3>{item.description}</h3>
                        <p>
                          Início: {new Date(item.start).toLocaleDateString("pt-BR") + " " +
                            new Date(item.start).toLocaleTimeString("pt-BR", { hour12: false })}
                        </p>
                        <p>
                          Fim: {new Date(item.end).toLocaleDateString("pt-BR") + " " +
                            new Date(item.end).toLocaleTimeString("pt-BR", { hour12: false })}
                        </p>
                      </IonLabel>
                      <IonButton
                        fill="clear"
                        slot="end"
                        color="danger"
                        onClick={() => deleteMerchantsInterruptions(item.id)}
                      >
                        <IonIcon icon={trashOutline} />
                      </IonButton>
                    </IonItem>
                  </IonList>
                </IonCardContent>
              </IonCard>
            ))}
          </IonContent>

          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => {
              setStartDate("");  // Limpa o campo de data de início
              setStartTime("");  // Limpa o campo de hora de início
              setEndDate("");    // Limpa o campo de data de término
              setEndTime("");    // Limpa o campo de hora de término

              // Limpar o título da pausa
              setPauseTitle(""); // Limpa o título da pausa
              setShowPausaProgramada(true);
            }}>
              Pausa Programada
            </IonButton>
            <IonButton expand="block" color="primary" onClick={() => {
              setSelectedTime("");
              setSelectedReason("");
              setShowFecharLojaIfood(true);
            }}>
              Fechar Loja
            </IonButton>
          </IonFooter>


        </IonModal>

        <IonModal isOpen={showOpenHoursLojaIfood} onDidDismiss={() => { setShowOpenHoursLojaIfood(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Horários - Integração iFood</IonTitle>
              <IonButtons slot="start" onClick={() => setShowOpenHoursLojaIfood(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {/* <IonFab vertical="top" horizontal="end" slot="fixed">
              <IonFabButton color="tertiary" onClick={() => { getMerchantsOpenHours(); }} >
                <IonIcon color="light" icon={setTime}></IonIcon>
              </IonFabButton>
            </IonFab> */}
            {openHoursLojaIfood.shifts && Array.isArray(openHoursLojaIfood.shifts) && openHoursLojaIfood.shifts.map((item: any, index: any) => {
              // Função para converter duração (em minutos) para horas e minutos
              const formatDuration = (minutes: number) => {
                const hours = Math.floor(minutes / 60);
                const mins = minutes % 60;
                return `${hours} horas e ${mins} minutos`;
              };

              // Mapeamento dos dias da semana para português
              const daysOfWeekMap: { [key: string]: string } = {
                "MONDAY": "Segunda-feira",
                "TUESDAY": "Terça-feira",
                "WEDNESDAY": "Quarta-feira",
                "THURSDAY": "Quinta-feira",
                "FRIDAY": "Sexta-feira",
                "SATURDAY": "Sábado",
                "SUNDAY": "Domingo"
              };

              // Traduz o dia da semana
              const translatedDay = daysOfWeekMap[item.dayOfWeek] || item.dayOfWeek;

              return (
                <IonCard key={index}>
                  <IonCardContent>
                    <IonList>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>{translatedDay}</h3> {/* Usa o dia traduzido */}
                          <p>Começa: {item.start}</p>
                          <p>Duração: {formatDuration(item.duration)}</p> {/* Converte a duração */}
                        </IonLabel>
                        <IonButton
                          fill="clear"
                          slot="end"
                          color="primary"
                          onClick={() => {
                            setIdOpenHour(item.id);
                            setDayOfWeekOpenHour(item.dayOfWeek);
                            setStartOpenHour(item.start);
                            setDurationOpenHour(item.duration);
                            setShowAlterarHorarioLojaIfood(true);
                          }}
                        >
                          <IonIcon icon={pencilOutline} />
                        </IonButton>
                        <IonButton
                          fill="clear"
                          slot="end"
                          color="danger"
                          onClick={() => {

                            putMerchantsOpenHoursRemover(item.id);

                          }}
                        >
                          <IonIcon icon={trashOutline} />
                        </IonButton>
                      </IonItem>
                    </IonList>
                  </IonCardContent>
                </IonCard>
              );
            })}

          </IonContent>

          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => {
              setIdOpenHour("");
              setDayOfWeekOpenHour("");
              setStartOpenHour("");
              setDurationOpenHour("");
              setShowAlterarHorarioLojaIfood(true);
            }
            }>
              Adicionar horário
            </IonButton>
          </IonFooter>

        </IonModal>

        <IonModal isOpen={showAlterarHorarioLojaIfood} onDidDismiss={() => setShowAlterarHorarioLojaIfood(false)}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Alterar Horário Loja - Integração iFood</IonTitle>
              <IonButtons slot="start">
                <IonButton onClick={() => setShowAlterarHorarioLojaIfood(false)}>
                  <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>

          <IonContent className="ion-padding">
            <IonList>
              <IonItem>
                <IonLabel position="stacked">Dia da Semana</IonLabel>
                <IonSelect
                  value={dayOfWeekOpenHour}
                  placeholder="Selecione um dia"
                  onIonChange={(e) => setDayOfWeekOpenHour(e.detail.value)}
                >
                  <IonSelectOption value="MONDAY">Segunda-feira</IonSelectOption>
                  <IonSelectOption value="TUESDAY">Terça-feira</IonSelectOption>
                  <IonSelectOption value="WEDNESDAY">Quarta-feira</IonSelectOption>
                  <IonSelectOption value="THURSDAY">Quinta-feira</IonSelectOption>
                  <IonSelectOption value="FRIDAY">Sexta-feira</IonSelectOption>
                  <IonSelectOption value="SATURDAY">Sábado</IonSelectOption>
                  <IonSelectOption value="SUNDAY">Domingo</IonSelectOption>
                </IonSelect>
              </IonItem>


              <IonItem>
                <IonLabel position="stacked">Hora de Início</IonLabel>
                <IonSelect
                  value={startOpenHour}
                  placeholder="Selecione um horário"
                  onIonChange={(e) => setStartOpenHour(e.detail.value)}
                >
                  {generateTimeOptions2359().map((time: any, index: any) => (
                    <IonSelectOption key={index} value={time}>
                      {time}
                    </IonSelectOption>
                  ))}
                </IonSelect>
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">Duração</IonLabel>
                <IonSelect
                  value={durationOpenHour}
                  placeholder="Selecione a duração"
                  onIonChange={(e) => handleDurationChange(e.detail.value)}
                >
                  {generateDurationOptions().map((duration: any, index: any) => (
                    <IonSelectOption key={index} value={duration}>
                      {formatDuration(duration)}
                    </IonSelectOption>
                  ))}
                </IonSelect>
              </IonItem>


            </IonList>
          </IonContent>

          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => putMerchantsOpenHours()}>
              Salvar
            </IonButton>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={showFecharLojaIfood} onDidDismiss={() => setShowFecharLojaIfood(false)}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Fechar Loja - Integração iFood</IonTitle>
              <IonButtons slot="start">
                <IonButton onClick={() => setShowFecharLojaIfood(false)}>
                  <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>

          <IonContent className="ion-padding">
            <div>
              <h2>Informe o motivo do fechamento.</h2>

              <IonList>
                <IonItem lines="none">
                  <IonLabel>Fechar por quanto tempo?</IonLabel>
                </IonItem>
                <IonRadioGroup value={selectedTime} onIonChange={(e) => setSelectedTime(e.detail.value)}>
                  <IonItem lines="none">
                    <IonLabel>15 min</IonLabel>
                    <IonRadio slot="start" value="15m" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>30 min</IonLabel>
                    <IonRadio slot="start" value="30m" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>1 h</IonLabel>
                    <IonRadio slot="start" value="1h" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>3 h</IonLabel>
                    <IonRadio slot="start" value="3h" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>6 h</IonLabel>
                    <IonRadio slot="start" value="6h" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>12 h</IonLabel>
                    <IonRadio slot="start" value="12h" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>24 h</IonLabel>
                    <IonRadio slot="start" value="24h" />
                  </IonItem>
                </IonRadioGroup>
              </IonList>
              <IonList>
                <IonItem lines="none">
                  <IonLabel>Qual o motivo?</IonLabel>
                </IonItem>
                <IonRadioGroup value={selectedReason} onIonChange={(e) => setSelectedReason(e.detail.value)}>
                  <IonItem lines="none">
                    <IonLabel>Muitos pedidos</IonLabel>
                    <IonRadio slot="start" value="Muitos pedidos" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>Manutenção/Problemas Técnicos</IonLabel>
                    <IonRadio slot="start" value="Manutenção/Problemas Técnicos" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>Horário de Funcionamento/Feriado</IonLabel>
                    <IonRadio slot="start" value="Horário de Funcionamento/Feriado" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>Falta de Equipe/Problemas Pessoais</IonLabel>
                    <IonRadio slot="start" value="Falta de Equipe/Problemas Pessoais" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>Problemas de Logística</IonLabel>
                    <IonRadio slot="start" value="Problemas de Logística" />
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>Outros</IonLabel>
                    <IonRadio slot="start" value="Outros" />
                  </IonItem>
                </IonRadioGroup>
              </IonList>
            </div>
          </IonContent>

          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => postMerchantsInterruptions()}>
              Fechar Loja
            </IonButton>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={showPausaProgramada} onDidDismiss={() => setShowPausaProgramada(false)}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Criar Pausa Programada</IonTitle>
              <IonButtons slot="start">
                <IonButton onClick={() => setShowPausaProgramada(false)}>
                  <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>

          <IonContent className="ion-padding">
            <div>
              <h3>A loja ficará indisponível nesta data, mesmo que esteja dentro do horário de funcionamento e o Gestor de Pedidos estiver aberto.</h3>

              {/* Título da pausa programada */}
              <IonItem>
                <IonLabel position="stacked">Título da Pausa Programada</IonLabel>
                <IonInput placeholder="Digite o título" onIonChange={(e) => setPauseTitle(e.detail.value!)} />
              </IonItem>

              {/* Começa em */}
              <div>
                <IonItem>
                  <IonLabel position="stacked" style={{ paddingBottom: "14px" }}>Começa em</IonLabel>
                  <IonDatetime
                    presentation="date"
                    onIonChange={(e) => setStartDate(e.detail.value!)}
                  />
                </IonItem>

                <IonItem>
                  <IonLabel position="stacked" style={{ paddingBottom: "14px" }}>Hora de início</IonLabel>
                  <IonSelect
                    value={startTime}
                    placeholder="Selecione um horário"
                    onIonChange={(e) => setStartTime(e.detail.value)}
                  >
                    {generateTimeOptions2359().map((time: any, index: any) => (
                      <IonSelectOption key={index} value={time}>
                        {time}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>

                {/* Termina em */}
                <IonItem>
                  <IonLabel position="stacked" style={{ paddingBottom: "14px" }}>Termina em</IonLabel>
                  <IonDatetime
                    presentation="date"
                    onIonChange={(e) => setEndDate(e.detail.value!)}
                  />
                </IonItem>

                <IonItem>
                  <IonLabel position="stacked" style={{ paddingBottom: "14px" }}>Hora de término</IonLabel>
                  <IonSelect
                    value={endTime}
                    placeholder="Selecione um horário"
                    onIonChange={(e) => setEndTime(e.detail.value)}
                  >
                    {generateTimeOptions2359().map((time: any, index: any) => (
                      <IonSelectOption key={index} value={time}>
                        {time}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              </div>
            </div>
          </IonContent>

          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => postMerchantsInterruptionsPausa()}>
              Salvar pausa programada
            </IonButton>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={mercadoPago1} onDidDismiss={fecharAtivacaoMercadoPago}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração Mercado Pago - Point</IonTitle>
              <IonButtons slot="start" onClick={fecharAtivacaoMercadoPago}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
              <IonItem lines="none" style={{ justifyContent: "center" }}>
                <img style={{ width: '120px', borderRadius: '5px' }} src={iconMercadopago} alt="Mercado Pago icon" />
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Ao integrar, os pagamentos serão automaticamente vinculados a sua Maquininha Point para realizar os pagamentos
                </div>
              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>
                  {mercadoPagoConfigurado
                    ? <>Já existe uma credencial cadastrada. Informe um novo <b>Access Token</b> somente para substituí-la.</>
                    : <>Entre com a <b>credencial de produção - Access Token</b> em: <a href={`https://www.mercadopago.com.br/developers`} target="_blank" rel="noopener noreferrer">https://www.mercadopago.com.br/developers</a></>}
                </div>




              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>


                  <IonInput
                    type="password"
                    style={{
                      textAlign: "center",
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#7D7D7D",
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "12px"
                    }}
                    value={mercadoPagoAccessToken}
                    onIonInput={(e: any) => setMercadoPagoAccessToken(e.detail.value || "")}
                    placeholder={mercadoPagoConfigurado ? 'Informe um novo Access Token' : 'APP_USR-132131...'}
                  />

                </div>
              </IonItem>
            </IonList>

          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" disabled={!mercadoPagoAccessToken.trim()} onClick={(e) => {

              const accessToken = mercadoPagoAccessToken.trim();
              if (!accessToken) {
                setTextToast("Informe o Access Token do Mercado Pago.");
                setShowToast(true);
                return;
              }

              setShowLoading(true);
              const objectRequest = {
                accessToken,
              };
              let id = loja;

              console.log("id", id)

              requestService(
                apiMercadoPagoCriarConfiguracao.url.replace("{id}", id.replaceAll("#", "%23")),
                {
                  method: apiMercadoPagoCriarConfiguracao.method,
                  body: JSON.stringify(objectRequest),
                  headers: [
                    ["token", window.localStorage.getItem("token")]
                  ],
                  credentials: 'include'
                },
                history,
                (response: any) => {
                  console.log(response);
                  if (response) {
                    setMercadoPagoConfigurado(true);
                    setMercadoPagoAccessToken("");
                    getTerminals();
                    console.log("Gravou as configurações de accessToken");

                    // Marcar etapa do onboarding como concluída
                    if (onboardingData && !onboardingData.onboarding_concluido) {
                      const urlOnb = onboardingAtualizarEtapa.url
                        .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
                      requestService(urlOnb, {
                        method: onboardingAtualizarEtapa.method,
                        body: JSON.stringify({ etapa_id: 'pix_automatizado', status: 'concluido' }),
                        headers: [["token", window.localStorage.getItem("token")]],
                        credentials: 'include'
                      }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
                    }
                  }
                  setShowLoading(false);
                },
                (error: any) => {
                  console.log(error);
                  setTextToast("Ocorreu um erro ao gravar o accessToken.");
                  setShowToast(true);
                  setShowLoading(false);
                })



            }}>Avançar</IonButton>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={mercadoPago2} onDidDismiss={() => { setMercadoPago2(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração Mercado Pago - Terminals</IonTitle>
              <IonButtons slot="start" onClick={() => setMercadoPago2(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaTerminals()}
            </IonList>
          </IonContent>

          {/* <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {
              setShowLojasIfood(false);
            }}>Remover integrações</IonButton>
          </IonFooter> */}
        </IonModal>

        {/* Modal Pix Automatizado */}
        <IonModal isOpen={showModalPixAutomatizado} onDidDismiss={() => setShowModalPixAutomatizado(false)}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração Pix Automatizado</IonTitle>
              <IonButtons slot="start" onClick={() => setShowModalPixAutomatizado(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
              <IonItem lines="none" style={{ justifyContent: "center" }}>
                <img style={{ width: '100px', borderRadius: '5px' }} src={iconPixAutomatizado} alt="Pix Automatizado icon" />
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Com o <strong>Pix Automatizado</strong>, seus clientes pagam em segundos, sem precisar de atendimento manual.
                  O sistema gera automaticamente um <strong>QR Code</strong> ou uma <strong>chave copia e cola</strong>, garantindo rapidez, praticidade e segurança em cada venda.
                </div>
              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>
                  <strong>Taxa:</strong> 1,99% por transação<br />
                  <strong>Recebimento:</strong> Crédito imediato na conta do Mercado Pago<br />
                  <strong>Disponibilidade:</strong> Exclusivo para pedidos via Delivery
                </div>
              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>
                  Para ativar esta funcionalidade, é necessário autorizar o <strong>Xeguei</strong> a processar os pagamentos diretamente pela sua conta do <strong>Mercado Pago</strong>.
                </div>
              </IonItem>

            </IonList>

          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => {
              const authUrl = `https://auth.mercadopago.com.br/authorization?client_id=7337138253217936&response_type=code&platform_id=mp&redirect_uri=https://y2i44jhb22.execute-api.sa-east-1.amazonaws.com/prd/mobile/ordens/callbackautorizacao&state=${encodeURIComponent(loja)}`;
              window.open(authUrl, '_blank');
              setShowModalPixAutomatizado(false);
            }}>
              Autorizar Mercado Pago
            </IonButton>
          </IonFooter>
        </IonModal>

        {/* ========================================
            MODAIS 99FOOD
        ======================================== */}

        {/* Modal 99Food - Passo 1: Informar ID da loja */}
        <IonModal isOpen={ativar99Food1} onDidDismiss={() => { setAtivar99Food1(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração 99Food</IonTitle>
              <IonButtons slot="start" onClick={() => setAtivar99Food1(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
              <IonItem lines="none" style={{ justifyContent: "center" }}>
                <img style={{ width: '120px', borderRadius: '5px' }} src={icon99Food} alt="99Food icon" />
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Ao integrar, os pedidos do 99Food irão aparecer em {window.localStorage.getItem("servicoTipoPlural") || "Projetos"}
                </div>
              </IonItem>

              <IonItem lines="none" style={{ flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <div>
                  Informe o <b>ID da loja na 99Food</b>:
                </div>
                {/* <div style={{ marginTop: 8, fontSize: 14, color: "#6B7280" }}>
                  Copie o ID da loja exibido no painel da 99Food.
                </div> */}
              </IonItem>


              <IonItem lines="none" style={{ justifyContent: "center", width: "100%", maxWidth: "300px" }}>
                <IonInput
                  style={{
                    textAlign: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#7D7D7D",
                    border: "1px solid #E0E0E0",
                    borderRadius: "8px",
                    padding: "12px"
                  }}
                  value={shopId99Food}
                  onIonInput={(e: any) => setShopId99Food(e.target.value)}
                  placeholder='Ex: 5764608531702219999'
                />
              </IonItem>

              <IonItem lines="none" style={{ width: "100%", maxWidth: "680px" }}>
                <div
                  style={{
                    width: "100%",
                    background: "#fff8f3",
                    border: "1px solid #ff7000",
                    borderRadius: "10px",
                    padding: "16px",
                    color: "#000",
                    textAlign: "left",
                    lineHeight: 1.45
                  }}
                >
                  <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
                    Onde encontrar o ID da loja?
                  </div>
                  <div>1. Acesse o painel 99Food em <a href="https://merchant.99app.com/pt-BR/manager/overview" target="_blank" rel="noopener noreferrer">https://merchant.99app.com/pt-BR/manager/overview</a></div>
                  <div>2. Faça login com sua conta</div>
                  <div>3. Acesse o menu Lojas e selecione a loja</div>
                  <div>4. Copie o campo ID da loja, usando apenas números</div>
                  {/* <div>5. Repita para cada loja que deseja integrar</div> */}
                </div>
              </IonItem>


            </IonList>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => {
              if (!shopId99Food.trim()) {
                setTextToast("Informe o ID da loja na 99Food.");
                setShowToast(true);
                return;
              }
              getAuthorizationUrl99Food();
            }}>Gerar link de autorização</IonButton>
          </IonFooter>
        </IonModal>

        {/* Modal 99Food - Passo 2: Autorização e obtenção de token */}
        <IonModal isOpen={ativar99Food2} onDidDismiss={() => { setAtivar99Food2(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Integração 99Food</IonTitle>
              <IonButtons slot="start" onClick={() => setAtivar99Food2(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
              <IonItem lines="none" style={{ justifyContent: "center" }}>
                <img style={{ width: '120px', borderRadius: '5px' }} src={icon99Food} alt="99Food icon" />
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Clique no link abaixo para autorizar a integração no portal do 99Food:
                </div>
              </IonItem>

              <IonItem lines="none" style={{ textAlign: "center", justifyContent: "center" }}>
                <div>
                  <a
                    href={authorizationUrl99Food}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Abrir portal de autorização 99Food
                  </a>
                </div>
              </IonItem>

              <IonItem lines="none" style={{ justifyContent: "center", textAlign: "center" }}>
                <div>
                  Após autorizar no portal do 99Food, clique em <b>Integrar</b> para concluir.
                </div>
              </IonItem>
            </IonList>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={() => {
              getToken99Food();
            }}>Integrar</IonButton>
          </IonFooter>
        </IonModal>

        {/* Modal 99Food - Lista de lojas */}
        <IonModal isOpen={showLojas99Food} onDidDismiss={() => { setShowLojas99Food(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Lojas 99Food</IonTitle>
              <IonButtons slot="start" onClick={() => setShowLojas99Food(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaLojas99Food()}
            </IonList>
          </IonContent>
        </IonModal>

        {/* Modal 99Food - Detalhes da loja */}
        <IonModal isOpen={showDetalhe99Food} onDidDismiss={() => { setShowDetalhe99Food(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Detalhes - 99Food</IonTitle>
              <IonButtons slot="start" onClick={() => setShowDetalhe99Food(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {detalhe99Food && (
              <IonCard>
                <IonCardContent>
                  <IonList>
                    <IonItem lines="none">
                      <IonLabel>
                        <h3>{detalhe99Food.shopName || "Loja 99Food"}</h3>
                        <p>ID da loja 99Food: {detalhe99Food.shopId99Food || "Nao informado"}</p>
                        <p>ID interno: {detalhe99Food.appShopId || "Nao informado"}</p>
                      </IonLabel>
                    </IonItem>
                    {detalhe99Food.shopAddress && (
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Endereço</h3>
                          <p>{detalhe99Food.shopAddress}</p>
                        </IonLabel>
                      </IonItem>
                    )}
                    {detalhe99Food.shopPhone && (
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Telefone</h3>
                          <p>{detalhe99Food.shopPhone}</p>
                        </IonLabel>
                      </IonItem>
                    )}
                    {detalhe99Food.categoryName && (
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Categoria principal</h3>
                          <p>{detalhe99Food.categoryName}</p>
                        </IonLabel>
                      </IonItem>
                    )}
                    {detalhe99Food.promiseProduceTimeLabel && (
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Tempo de preparo</h3>
                          <p>{detalhe99Food.promiseProduceTimeLabel}</p>
                        </IonLabel>
                      </IonItem>
                    )}
                    {detalhe99Food.businessHoursLabel && (
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Horário de funcionamento</h3>
                          <p>{detalhe99Food.businessHoursLabel}</p>
                        </IonLabel>
                      </IonItem>
                    )}
                    <IonItem lines="none">
                      <IonLabel>
                        <h3>Status</h3>
                        <p>{detalhe99Food.statusLabel || (detalhe99Food.isOpen ? "Aberta" : "Fechada")}</p>
                        {detalhe99Food.autoSwitchLabel && <p>Auto switch: {detalhe99Food.autoSwitchLabel}</p>}
                      </IonLabel>
                    </IonItem>
                  </IonList>
                </IonCardContent>
              </IonCard>
            )}
          </IonContent>
          <IonFooter>
            <IonGrid>
              <IonRow>
                <IonCol>
                  <IonButton expand="block" color="success" onClick={() => setShopStatus99Food(detalhe99Food?.appShopId, 1)}>
                    Abrir Loja
                  </IonButton>
                </IonCol>
                <IonCol>
                  <IonButton expand="block" color="danger" onClick={() => setShopStatus99Food(detalhe99Food?.appShopId, 2)}>
                    Fechar Loja
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonFooter>
        </IonModal>

        {/* Modal 99Food - Diagnóstico */}
        <IonModal isOpen={showDiagnostico99Food} onDidDismiss={() => { setShowDiagnostico99Food(false); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Diagnóstico - 99Food</IonTitle>
              <IonButtons slot="start" onClick={() => setShowDiagnostico99Food(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {diagnostico99Food && (
              <>
                <IonCard>
                  <IonCardContent>
                    <IonList>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>APP ID ativo</h3>
                          <p>{diagnostico99Food.appId || "Nao informado"}</p>
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Segredo configurado</h3>
                          <p>{diagnostico99Food.appSecretConfigured ? "Sim" : "Nao"}</p>
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Empresa</h3>
                          <p>{diagnostico99Food.empresa || "Nao informado"}</p>
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>
                          <h3>Total de lojas locais</h3>
                          <p>{diagnostico99Food.totalLojas ?? 0}</p>
                        </IonLabel>
                      </IonItem>
                    </IonList>
                  </IonCardContent>
                </IonCard>

                {(diagnostico99Food.lojas || []).length > 0 ? (
                  (diagnostico99Food.lojas || []).map((item: any, index: number) => (
                    <IonCard key={`diagnostico99food-${item.appShopId || index}`}>
                      <IonCardContent>
                        <IonList>
                          <IonItem lines="none">
                            <IonLabel>
                              <h3>{item.shopName || item.shopId99Food || "Loja 99Food"}</h3>
                              <p>ID da loja 99Food: {item.shopId99Food || "Nao informado"}</p>
                              <p>Token local: {item.authTokenPresent ? "Presente" : "Ausente"}</p>
                              <p>Token expirado: {item.tokenExpired === null ? "Nao informado" : item.tokenExpired ? "Sim" : "Nao"}</p>
                              <p>Expira em: {formatTimestamp99Food(item.tokenExpirationTime)}</p>
                            </IonLabel>
                          </IonItem>
                        </IonList>
                      </IonCardContent>
                    </IonCard>
                  ))
                ) : (
                  <IonCard>
                    <IonCardContent>
                      Nenhuma loja 99Food foi salva localmente para esta empresa.
                    </IonCardContent>
                  </IonCard>
                )}

                <IonCard>
                  <IonCardContent>
                    <p style={{ margin: 0 }}>{diagnostico99Food.observacao}</p>
                  </IonCardContent>
                </IonCard>
              </>
            )}
          </IonContent>
          <IonFooter>
            <IonGrid>
              <IonRow>
                <IonCol>
                  <IonButton expand="block" fill="outline" onClick={() => copyDiagnostic99Food()}>
                    <IonIcon slot="start" icon={copy}></IonIcon>
                    Copiar
                  </IonButton>
                </IonCol>
                <IonCol>
                  <IonButton expand="block" onClick={() => setShowDiagnostico99Food(false)}>
                    Fechar
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonFooter>
        </IonModal>

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showSucesso}
          onDidDismiss={(e: any) => { setShowSucesso(false); history.goBack(); }}
          message={'Alterações salvas com sucesso!'}
          duration={3000}
          animated={false}
        />
      </IonContent >

    </IonPage >
  );
};

export default Integracoes;
